export const mockCompanies = {
  "clay-001": {
    company_id: "clay-001",
    name: "Clay",
    status: "Active",
    industry: "Business/Productivity Software",
    founded: "2016",
    celebrity_investors: ["Ashton Kutcher", "Jared Leto"],
    website: "https://clay.com",
    description: "Clay is a creative tool that combines spreadsheet power with AI to help go-to-market teams build highly targeted lead lists and personalized outreach campaigns.",
    keywords: ["SaaS", "AI", "Productivity", "Sales", "Marketing"],
    
    // Detailed data
    latest_funding: {
      round_type: "Series B",
      date: "2024-11-15",
      amount: 62000000,
      valuation: 500000000,
      lead_investor: "Sequoia Capital",
      other_investors: ["Sound Ventures", "Paradox Ventures", "FirstMark Capital"]
    },
    financials: {
      revenue: {
        "2023": 15000000,
        "2024_projected": 45000000
      },
      arr: 45000000,
      growth_rate: 200,
      burn_rate: 2500000,
      runway_months: 25
    },
    team: [
      {
        name: "Kareem Amin",
        role: "CEO & Co-Founder",
        background: "Previously VP Product at Palantir"
      },
      {
        name: "Varun Anand",
        role: "CTO & Co-Founder",
        background: "Previously Engineering at Facebook"
      }
    ],
    deal_history: [
      {
        date: "2024-11-15",
        round: "Series B",
        amount: 62000000,
        valuation: 500000000
      },
      {
        date: "2022-06-01",
        round: "Series A",
        amount: 16000000,
        valuation: 160000000
      },
      {
        date: "2020-09-01",
        round: "Seed",
        amount: 5500000,
        valuation: 25000000
      }
    ],
    cap_table: {
      founders: 35,
      employees: 10,
      investors: {
        "Sequoia Capital": 15,
        "FirstMark Capital": 12,
        "Sound Ventures": 3,
        "Other investors": 25
      }
    },
    cap_table_history: [
      {
        series: "Series B",
        shares_authorized: 2500000,
        par_value: "$0.000010",
        dividend_rate: "$1.24",
        original_issue_price: "$24.80",
        liquidation: "$24.80",
        liquidation_multiple: "1x",
        conversion_price: "$24.80",
        percent_owned: "15.00"
      },
      {
        series: "Series A",
        shares_authorized: 2000000,
        par_value: "$0.000010",
        dividend_rate: "$0.16",
        original_issue_price: "$3.20",
        liquidation: "$3.20",
        liquidation_multiple: "1x",
        conversion_price: "$3.20",
        percent_owned: "12.00"
      },
      {
        series: "Seed",
        shares_authorized: 3618502,
        par_value: "$0.000010",
        dividend_rate: "$0.03",
        original_issue_price: "$0.55",
        liquidation: "$0.55",
        liquidation_multiple: "1x",
        conversion_price: "$0.55",
        percent_owned: "13.00"
      },
      {
        series: "Common Stock",
        shares_authorized: 10000000,
        par_value: "$0.000010",
        dividend_rate: "-",
        original_issue_price: "-",
        liquidation: "-",
        liquidation_multiple: "-",
        conversion_price: "-",
        percent_owned: "60.00"
      }
    ],
    series_terms: {
      series_list: "A, B, Seed",
      liquidation_preferences: "Pari Passu",
      participating: "Non-participating",
      dividend_rights: "Yes",
      cumulative: "Non-Cumulative",
      anti_dilution: "Weighted Average",
      redemption_rights: "No",
      board_voting_rights: "Yes",
      general_voting_rights: "Yes"
    },
    investors: [
      {
        name: "Ashton Kutcher",
        type: "Angel (individual)",
        firm: "Sound Ventures",
        holding: "Minority",
        since: "Nov 2024",
        board_member: false,
        amount: 5000000,
        rounds: ["Series B"],
        related_deals: "#4. Series B: Nov 2024, $62.00M, New Investor"
      },
      {
        name: "Jared Leto",
        type: "Angel (individual)", 
        firm: "Paradox Ventures",
        holding: "Minority",
        since: "Nov 2024",
        board_member: false,
        amount: 2000000,
        rounds: ["Series B"],
        related_deals: "#4. Series B: Nov 2024, $62.00M, New Investor"
      },
      {
        name: "Sequoia Capital",
        type: "Venture Capital",
        holding: "Minority",
        since: "Jun 2022",
        board_member: true,
        related_deals: "#4. Series B: Nov 2024, $62.00M, Lead Investor | #3. Series A: Jan 2023, $13.50M, Lead Investor"
      },
      {
        name: "FirstMark Capital",
        type: "Venture Capital",
        holding: "Minority", 
        since: "Jan 2023",
        board_member: true,
        related_deals: "#3. Series A: Jan 2023, $13.50M, New Investor"
      }
    ]
  },
  
  "uber-002": {
    company_id: "uber-002",
    name: "Uber",
    status: "Public",
    industry: "Transportation",
    founded: "2009",
    celebrity_investors: ["Ashton Kutcher", "Olivia Munn"],
    website: "https://uber.com",
    description: "Uber is a technology platform that connects riders with drivers, delivery partners with restaurants and consumers, and freight shippers with carriers.",
    keywords: ["Transportation", "Gig Economy", "Marketplace", "Mobility"],
    
    latest_funding: {
      round_type: "IPO",
      date: "2019-05-10",
      amount: 8100000000,
      valuation: 82400000000,
      lead_investor: "Public Markets",
      stock_price: 45.00
    },
    financials: {
      revenue: {
        "2023": 37281000000,
        "2024_projected": 41000000000
      },
      market_cap: 147000000000,
      growth_rate: 10,
      profitability: "Profitable since Q3 2023"
    },
    team: [
      {
        name: "Dara Khosrowshahi",
        role: "CEO",
        background: "Previously CEO at Expedia"
      },
      {
        name: "Nelson Chai",
        role: "CFO",
        background: "Previously CFO at CIT Group"
      }
    ],
    deal_history: [
      {
        date: "2019-05-10",
        round: "IPO",
        amount: 8100000000,
        valuation: 82400000000
      },
      {
        date: "2018-01-01",
        round: "Series G",
        amount: 1250000000,
        valuation: 68000000000
      },
      {
        date: "2010-08-01",
        round: "Series A",
        amount: 1250000,
        valuation: 4000000
      }
    ],
    cap_table: {
      public_float: 65,
      institutional: 25,
      insiders: 10
    },
    investors: [
      {
        name: "Ashton Kutcher",
        firm: "Sound Ventures",
        amount: 500000,
        rounds: ["Series A"],
        exit_value: 125000000
      }
    ]
  },
  
  "spotify-003": {
    company_id: "spotify-003",
    name: "Spotify",
    status: "Public",
    industry: "Media & Entertainment",
    founded: "2006",
    celebrity_investors: ["Ashton Kutcher", "Jared Leto", "Justin Bieber"],
    website: "https://spotify.com",
    description: "Spotify is a digital music, podcast, and video service that gives you access to millions of songs and other content from creators all over the world.",
    keywords: ["Music", "Streaming", "Entertainment", "Podcasts"],
    
    latest_funding: {
      round_type: "Public Company",
      date: "2018-04-03",
      stock_symbol: "SPOT",
      market_cap: 25000000000,
      current_stock_price: 155.50
    },
    financials: {
      revenue: {
        "2023": 13247000000,
        "2024_projected": 15000000000
      },
      subscribers: 246000000,
      market_cap: 28500000000,
      growth_rate: 13
    },
    team: [
      {
        name: "Daniel Ek",
        role: "CEO & Co-Founder",
        background: "Founded Advertigo (acquired by TradeDoubler)"
      },
      {
        name: "Gustav Söderström",
        role: "Co-President & CTO",
        background: "Joined Spotify in 2009"
      }
    ],
    deal_history: [
      {
        date: "2018-04-03",
        round: "Direct Listing",
        valuation: 29500000000
      },
      {
        date: "2016-03-01",
        round: "Series G",
        amount: 1000000000,
        valuation: 8530000000
      },
      {
        date: "2012-11-01",
        round: "Series D",
        amount: 100000000,
        valuation: 3000000000
      }
    ],
    investors: [
      {
        name: "Ashton Kutcher",
        firm: "Sound Ventures",
        amount: 3000000,
        rounds: ["Series D"]
      },
      {
        name: "Jared Leto",
        firm: "Paradox Ventures",
        amount: 2000000,
        rounds: ["Series D"]
      }
    ]
  },
  
  "airbnb-004": {
    company_id: "airbnb-004",
    name: "Airbnb",
    status: "Public",
    industry: "Travel & Hospitality",
    founded: "2008",
    celebrity_investors: ["Ashton Kutcher"],
    website: "https://airbnb.com",
    description: "Airbnb is an online marketplace that connects people who want to rent out their homes with people looking for accommodations in specific locales.",
    keywords: ["Travel", "Hospitality", "Marketplace", "Sharing Economy"],
    
    latest_funding: {
      round_type: "Public Company",
      date: "2020-12-10",
      stock_symbol: "ABNB",
      ipo_price: 68,
      current_stock_price: 145.25
    },
    financials: {
      revenue: {
        "2023": 9917000000,
        "2024_projected": 11000000000
      },
      market_cap: 93000000000,
      growth_rate: 11,
      profitability: "Profitable"
    },
    team: [
      {
        name: "Brian Chesky",
        role: "CEO & Co-Founder",
        background: "Industrial Designer from RISD"
      },
      {
        name: "Dave Stephenson",
        role: "CFO",
        background: "Previously at Amazon"
      }
    ],
    deal_history: [
      {
        date: "2020-12-10",
        round: "IPO",
        amount: 3500000000,
        valuation: 47000000000
      },
      {
        date: "2017-03-01",
        round: "Series F",
        amount: 1000000000,
        valuation: 31000000000
      },
      {
        date: "2011-07-01",
        round: "Series B",
        amount: 112000000,
        valuation: 1300000000
      }
    ],
    investors: [
      {
        name: "Ashton Kutcher",
        firm: "Sound Ventures",
        amount: 2500000,
        rounds: ["Series B"],
        current_value: 45000000
      }
    ]
  },
  
  "goop-005": {
    company_id: "goop-005",
    name: "Goop",
    status: "Active",
    industry: "Wellness & Lifestyle",
    founded: "2008",
    celebrity_investors: ["Gwyneth Paltrow"],
    website: "https://goop.com",
    description: "Goop is a wellness and lifestyle brand that curates products, content, and experiences designed to help people live their best lives.",
    keywords: ["Wellness", "E-commerce", "Content", "Beauty", "Lifestyle"],
    
    latest_funding: {
      round_type: "Series C",
      date: "2019-03-01",
      amount: 50000000,
      valuation: 250000000,
      lead_investor: "NEA",
      other_investors: ["Lightspeed Venture Partners", "Felix Capital"]
    },
    financials: {
      revenue: {
        "2023": 75000000,
        "2024_projected": 95000000
      },
      growth_rate: 27,
      categories: {
        "E-commerce": 65,
        "Content & Media": 20,
        "Experiences": 15
      }
    },
    team: [
      {
        name: "Gwyneth Paltrow",
        role: "Founder & CEO",
        background: "Academy Award-winning actress"
      },
      {
        name: "Elise Loehnen",
        role: "Chief Content Officer",
        background: "Previously at Conde Nast"
      }
    ],
    deal_history: [
      {
        date: "2019-03-01",
        round: "Series C",
        amount: 50000000,
        valuation: 250000000
      },
      {
        date: "2016-08-01",
        round: "Series B",
        amount: 15000000,
        valuation: 60000000
      }
    ],
    cap_table: {
      "Gwyneth Paltrow": 30,
      "NEA": 20,
      "Lightspeed": 15,
      "Other investors": 35
    },
    investors: [
      {
        name: "Gwyneth Paltrow",
        role: "Founder",
        amount: 10000000,
        rounds: ["Founding", "Series B"]
      }
    ]
  },
  
  "openai-006": {
    company_id: "openai-006",
    name: "OpenAI",
    status: "Active",
    industry: "Artificial Intelligence",
    founded: "2015",
    celebrity_investors: ["Ashton Kutcher"],
    website: "https://openai.com",
    description: "OpenAI is an AI research and deployment company that develops and promotes friendly AI for the benefit of all humanity.",
    keywords: ["AI", "Machine Learning", "GPT", "ChatGPT", "Research"],
    
    latest_funding: {
      round_type: "Series F",
      date: "2024-11-01",
      amount: 6600000000,
      valuation: 157000000000,
      lead_investor: "Thrive Capital",
      other_investors: ["Microsoft", "Khosla Ventures", "Sound Ventures"]
    },
    financials: {
      revenue: {
        "2023": 1600000000,
        "2024_projected": 3400000000
      },
      arr: 3400000000,
      growth_rate: 112,
      users: 200000000
    },
    team: [
      {
        name: "Sam Altman",
        role: "CEO",
        background: "Previously President of Y Combinator"
      },
      {
        name: "Mira Murati",
        role: "CTO",
        background: "Previously at Tesla"
      }
    ],
    deal_history: [
      {
        date: "2024-11-01",
        round: "Series F",
        amount: 6600000000,
        valuation: 157000000000
      },
      {
        date: "2023-04-01",
        round: "Series E",
        amount: 300000000,
        valuation: 29000000000
      },
      {
        date: "2019-07-01",
        round: "Series A",
        amount: 1000000000,
        valuation: 1000000000,
        notes: "Microsoft investment"
      }
    ],
    cap_table: {
      "Microsoft": 49,
      "Employees": 20,
      "Thrive Capital": 10,
      "Other investors": 21
    },
    investors: [
      {
        name: "Ashton Kutcher",
        firm: "Sound Ventures",
        amount: 10000000,
        rounds: ["Series F"]
      }
    ]
  },

  // Jared Leto's portfolio companies
  "719403-94": {
    company_id: "719403-94",
    name: "Aetherflux",
    status: "Active",
    industry: "Aerospace and Defense",
    founded: "2023-12-07",
    celebrity_investors: ["Jared Leto"],
    website: "www.aetherflux.com",
    description: "Operator of an aerospace company intended to provide renewable energy to households, businesses, and military operations globally. The company builds a constellation of small satellites that collect sunlight, convert it to electricity, and wirelessly transmit power to ground stations, enabling consumers to get reliable energy distribution with reduced environmental impact.",
    keywords: ["aerospace company","aerospace technology","renewable eneregy","renewable energy","renewable energy technology","solar power","solar power technology"],
    
    latest_funding: {
      round_type: "Series A",
      date: "2025-04-02",
      amount: 49999810,
      valuation: 269999996,
      post_money_valuation: 269999996,
      lead_investor: "Interlagos Capital",
      other_investors: ["Andreessen Horowitz","Brave Capital (San Francisco)","Breakthrough Energy","Draper Associates","F.P. Journe","Index Ventures","Jared Leto","laurent ferrier","New Enterprise Associates","Ravelin Capital","Vlad Tenev"]
    },
    
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 220000186
    },
    
    team: [
          {
                "name": "Baiju Bhatt",
                "role": "Founder & Chief Executive Officer",
                "background": ""
          }
    ],
    
    deal_history: [
          {
                "date": "2025-04-02",
                "round": "Series A",
                "amount": 49999810,
                "valuation": 269999996,
                "pre_money_valuation": 0,
                "investors": 13,
                "lead_investor": "Interlagos Capital"
          }
    ],
    
    cap_table: {
          "Series A": "18.52",
          "Seed": "12.74",
          "Common Stock": "68.74"
    },
    
    investors: [
          {
                "name": "Andreessen Horowitz",
                "firm": "Andreessen Horowitz",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "41716-90"
          },
          {
                "name": "Brave Capital (San Francisco)",
                "firm": "Brave Capital (San Francisco)",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "519246-28"
          },
          {
                "name": "Breakthrough Energy",
                "firm": "Breakthrough Energy",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "168856-57"
          },
          {
                "name": "Daniel Gallagher",
                "firm": "Daniel Gallagher",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "770227-66"
          },
          {
                "name": "Draper Associates",
                "firm": "Draper Associates",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "56010-97"
          },
          {
                "name": "F.P. Journe",
                "firm": "F.P. Journe",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "233085-97"
          },
          {
                "name": "Index Ventures",
                "firm": "Index Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "11216-98"
          },
          {
                "name": "Interlagos Capital",
                "firm": "Interlagos Capital",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "594258-31"
          },
          {
                "name": "Jared Leto",
                "firm": "Jared Leto",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "105876-55"
          },
          {
                "name": "laurent ferrier",
                "firm": "laurent ferrier",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "323438-59"
          },
          {
                "name": "New Enterprise Associates",
                "firm": "New Enterprise Associates",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "11251-81"
          },
          {
                "name": "Ravelin Capital",
                "firm": "Ravelin Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "562673-08"
          },
          {
                "name": "Vlad Tenev",
                "firm": "Vlad Tenev",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2025-04-02",
                "pitchbook_id": "226771-21"
          }
    ],
    
    board_members: [],
    
    investments_buy_side: []
  },

  "608847-76": {
    company_id: "608847-76",
    name: "Harmonic (Educational Software)",
    status: "Active",
    industry: "Educational Software",
    founded: "2023-01-01",
    celebrity_investors: ["Jared Leto"],
    website: "www.harmonic.fun",
    description: "Developer of a mathematical reasoning engine designed to explore the frontiers of human understanding. The company's application uses artificial intelligence that provides verifiably correct and interpretable outputs and accelerates the advent of verified software synthesis in safety-critical domains, enabling humans to solve open problems in mathematics, science, and beyond.",
    keywords: ["ai software","mathematics learning","maths platform","reasoning engine","science tools","software backend"],
    
    latest_funding: {
      round_type: "Series A",
      date: "2024-09-23",
      amount: 75000000,
      valuation: 325000000,
      post_money_valuation: 325000000,
      lead_investor: "Sequoia Capital",
      other_investors: ["Blossom Capital","DST Global","Era Funds","Fellows Fund","GreatPoint Ventures","Rainfall Ventures","TIBAS Ventures"]
    },
    
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 250000000
    },
    
    team: [
          {
                "name": "Vladimir Tenev",
                "role": "Co-Founder & Execuitve Chairman",
                "background": ""
          }
    ],
    
    deal_history: [
          {
                "date": "2024-09-23",
                "round": "Series A",
                "amount": 75000000,
                "valuation": 325000000,
                "pre_money_valuation": 0,
                "investors": 11,
                "lead_investor": "Sequoia Capital"
          },
          {
                "date": "2025-07-09",
                "round": "Series B",
                "amount": 100000000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 6,
                "lead_investor": "Sequoia Capital"
          }
    ],
    
    cap_table: {},
    
    investors: [
          {
                "name": "Charlie Cheever",
                "firm": "Charlie Cheever",
                "status": "Lead Investor",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2025-07-09",
                "pitchbook_id": "105899-14"
          },
          {
                "name": "Kleiner Perkins",
                "firm": "Kleiner Perkins",
                "status": "Lead Investor",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2025-07-09",
                "pitchbook_id": "11228-50"
          },
          {
                "name": "Paradigm (Crypto Fund)",
                "firm": "Paradigm (Crypto Fund)",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2025-07-09",
                "pitchbook_id": "233744-05"
          },
          {
                "name": "Ribbit Capital",
                "firm": "Ribbit Capital",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2025-07-09",
                "pitchbook_id": "55346-14"
          },
          {
                "name": "Blossom Capital",
                "firm": "Blossom Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "226255-51"
          },
          {
                "name": "DST Global",
                "firm": "DST Global",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "40773-97"
          },
          {
                "name": "Era Funds",
                "firm": "Era Funds",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "534493-54"
          },
          {
                "name": "Fellows Fund",
                "firm": "Fellows Fund",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "469899-37"
          },
          {
                "name": "GreatPoint Ventures",
                "firm": "GreatPoint Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "51254-02"
          },
          {
                "name": "Index Ventures",
                "firm": "Index Ventures",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "11216-98"
          },
          {
                "name": "Jared Leto",
                "firm": "Jared Leto",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "105876-55"
          },
          {
                "name": "Nikesh Arora",
                "firm": "Nikesh Arora",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "133147-81"
          },
          {
                "name": "Rainfall Ventures",
                "firm": "Rainfall Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "53345-35"
          },
          {
                "name": "Sequoia Capital",
                "firm": "Sequoia Capital",
                "status": "Lead Investor",
                "rounds": [
                      "Series B",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "11295-73"
          },
          {
                "name": "TIBAS Ventures",
                "firm": "TIBAS Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2024-09-23",
                "pitchbook_id": "539853-22"
          }
    ],
    
    board_members: [],
    
    investments_buy_side: []
  },

  "537093-55": {
    company_id: "537093-55",
    name: "Pika (Multimedia and Design Software)",
    status: "Active",
    industry: "Multimedia and Design Software",
    founded: "2023-01-01",
    celebrity_investors: ["Jared Leto"],
    website: "www.pika.art",
    description: "Developer of a text-to-video platform designed to offer artificial intelligence-based editing software for its users. The company's platform offers typing technology to unleash user's creativity to support the advancement of animation and editing, enabling users to revolutionize video animation with artificial intelligence.",
    keywords: ["animation technology","artificial intelligence","content creation","design software","editing software","text-to-video platform"],
    
    latest_funding: {
      round_type: "Series B",
      date: "2024-07-23",
      amount: 80000000,
      valuation: 470000000,
      post_money_valuation: 470000000,
      lead_investor: "Nat Friedman",
      other_investors: ["AIspace Ventures","AJI Capital","Beyond Capital","Greycroft","Makers Fund","NYX Ventures Partners","SaaS Ventures","Sarah Smith Fund","Spark Capital","Conviction Capital","Neo (Consulting Services (B2B))","SV Angel"]
    },
    
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 390000000
    },
    
    team: [
          {
                "name": "Demi Guo",
                "role": "Co-Founder & Chief Executive Officer",
                "background": ""
          }
    ],
    
    deal_history: [
          {
                "date": "2023-07-15",
                "round": "Seed",
                "amount": 20000000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 2,
                "lead_investor": "Nat Friedman"
          },
          {
                "date": "2023-09-07",
                "round": "Accelerator/Inc",
                "amount": 250000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 1,
                "lead_investor": ""
          },
          {
                "date": "2023-11-29",
                "round": "Series A",
                "amount": 34996350,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 25,
                "lead_investor": "Nat Friedman"
          },
          {
                "date": "2024-07-23",
                "round": "Series B",
                "amount": 80000000,
                "valuation": 470000000,
                "pre_money_valuation": 0,
                "investors": 27,
                "lead_investor": "Nat Friedman"
          }
    ],
    
    cap_table: {
          "Series A": "10.17",
          "Seed-3": "2.16",
          "Seed-2": "7.40",
          "Seed-1": "7.76",
          "Common Stock": "72.51"
    },
    
    investors: [
          {
                "name": "AIspace Ventures",
                "firm": "AIspace Ventures",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-07-23",
                "pitchbook_id": "537891-58"
          },
          {
                "name": "AJI Capital",
                "firm": "AJI Capital",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-07-23",
                "pitchbook_id": "234860-05"
          },
          {
                "name": "Beyond Capital",
                "firm": "Beyond Capital",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-07-23",
                "pitchbook_id": "517841-29"
          },
          {
                "name": "Greycroft",
                "firm": "Greycroft",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-07-23",
                "pitchbook_id": "11191-87"
          },
          {
                "name": "Jared Leto",
                "firm": "Jared Leto",
                "status": "Lead Investor",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-07-23",
                "pitchbook_id": "105876-55"
          },
          {
                "name": "Makers Fund",
                "firm": "Makers Fund",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-07-23",
                "pitchbook_id": "224332-66"
          },
          {
                "name": "NYX Ventures Partners",
                "firm": "NYX Ventures Partners",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-07-23",
                "pitchbook_id": "597247-12"
          },
          {
                "name": "SaaS Ventures",
                "firm": "SaaS Ventures",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-07-23",
                "pitchbook_id": "223411-60"
          },
          {
                "name": "Sarah Smith Fund",
                "firm": "Sarah Smith Fund",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-07-23",
                "pitchbook_id": "515918-71"
          },
          {
                "name": "Spark Capital",
                "firm": "Spark Capital",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2024-07-23",
                "pitchbook_id": "11303-02"
          },
          {
                "name": "Aaron Levie",
                "firm": "Aaron Levie",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "105859-36"
          },
          {
                "name": "Adam D'Angelo",
                "firm": "Adam D'Angelo",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Seed",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "106497-73"
          },
          {
                "name": "Alex Chung",
                "firm": "Alex Chung",
                "status": "Lead Investor",
                "rounds": [
                      "Series B",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "149224-96"
          },
          {
                "name": "Andrej Karpathy",
                "firm": "Andrej Karpathy",
                "status": "Lead Investor",
                "rounds": [
                      "Series B",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "495824-59"
          },
          {
                "name": "Aravind Srinivas",
                "firm": "Aravind Srinivas",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "530800-84"
          },
          {
                "name": "Ben's Bites",
                "firm": "Ben's Bites",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "541122-31"
          },
          {
                "name": "Clément Delangue",
                "firm": "Clément Delangue",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "483088-87"
          },
          {
                "name": "Conviction Capital",
                "firm": "Conviction Capital",
                "rounds": [
                      "Series B",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "496297-09"
          },
          {
                "name": "Conviction Partners",
                "firm": "Conviction Partners",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "510108-40"
          },
          {
                "name": "Craig Kallman",
                "firm": "Craig Kallman",
                "status": "Lead Investor",
                "rounds": [
                      "Series B",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "115259-05"
          },
          {
                "name": "Cristina Cordova",
                "firm": "Cristina Cordova",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "462641-68"
          },
          {
                "name": "Elad Gil",
                "firm": "Elad Gil",
                "status": "Lead Investor",
                "rounds": [
                      "Seed",
                      "Series A",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "106041-70"
          },
          {
                "name": "Eric Glyman",
                "firm": "Eric Glyman",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "442750-06"
          },
          {
                "name": "Factorial Capital",
                "firm": "Factorial Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "528915-43"
          },
          {
                "name": "Homebrew",
                "firm": "Homebrew",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "56078-47"
          },
          {
                "name": "Karim Atiyeh",
                "firm": "Karim Atiyeh",
                "status": "Lead Investor",
                "rounds": [
                      "Series B",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "442628-92"
          },
          {
                "name": "Keith Peiris",
                "firm": "Keith Peiris",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "553112-47"
          },
          {
                "name": "Lightspeed Venture Partners",
                "firm": "Lightspeed Venture Partners",
                "status": "Lead Investor",
                "rounds": [
                      "Series B",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "11333-26"
          },
          {
                "name": "Mateusz Staniszewski",
                "firm": "Mateusz Staniszewski",
                "status": "Lead Investor",
                "rounds": [
                      "Series B",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "553113-46"
          },
          {
                "name": "Mike Vernal",
                "firm": "Mike Vernal",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "154361-71"
          },
          {
                "name": "Neo (Consulting Services (B2B))",
                "firm": "Neo (Consulting Services (B2B))",
                "rounds": [
                      "Series B",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "56299-96"
          },
          {
                "name": "Sequoia Capital",
                "firm": "Sequoia Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "11295-73"
          },
          {
                "name": "SV Angel",
                "firm": "SV Angel",
                "rounds": [
                      "Series B",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "50980-60"
          },
          {
                "name": "Vipul Ved Prakash",
                "firm": "Vipul Ved Prakash",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-11-29",
                "pitchbook_id": "490701-88"
          },
          {
                "name": "AI Grant",
                "firm": "AI Grant",
                "rounds": [
                      "Accelerator/Inc"
                ],
                "stake": "Minority",
                "since": "2023-09-07",
                "pitchbook_id": "512930-08"
          },
          {
                "name": "Daniel Gross",
                "firm": "Daniel Gross",
                "status": "Lead Investor",
                "rounds": [
                      "Seed",
                      "Series B",
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2023-07-15",
                "pitchbook_id": "109607-50"
          },
          {
                "name": "Nat Friedman",
                "firm": "Nat Friedman",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Seed",
                      "Series B",
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2023-07-15",
                "pitchbook_id": "224112-70"
          }
    ],
    
    board_members: [],
    
    investments_buy_side: []
  },

  "183309-13": {
    company_id: "183309-13",
    name: "ZeroEx (San Francisco)",
    status: "Active",
    industry: "Financial Software",
    founded: "2017-01-01",
    celebrity_investors: ["Jared Leto"],
    website: "www.0x.org",
    description: "Developer of an open protocol designed for decentralized exchange on the Ethereum blockchain. The company's open protocol serves as an open standard and common building block, driving interoperability among decentralized applications that incorporate exchange functionality, enabling users to convert a variety of assets as cryptographic tokens.",
    keywords: ["bitcoin exchange","bitcoin exchange application","bitcoin exchange platform","blockchain protocol","crypto borrowing","crypto lending","crypto yield generation","decentralized exchange","defi","smart contracts"],
    
    latest_funding: {
      round_type: "Series B",
      date: "2022-04-15",
      amount: 70000000,
      valuation: 0,
      post_money_valuation: 0,
      lead_investor: "Pantera Capital",
      other_investors: ["A.Capital Ventures","Atlas Benjelloun","Blockwall Management","Brevan Howard Asset Management","Continue Capital","Cyberight Capital","Framework Ventures","GSR","Jared Leto","Jump Crypto","Nascent","OpenSea","Reid Hoffman","Sound Ventures","Coinbase Ventures"]
    },
    
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 0
    },
    
    team: [
          {
                "name": "Will Warren",
                "role": "Co-Founder, Co-Chief Executive Officer & Board Member",
                "background": ""
          }
    ],
    
    deal_history: [
          {
                "date": "2017-08-10",
                "round": "Seed",
                "amount": 0,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 13,
                "lead_investor": "Polychain Capital"
          },
          {
                "date": "2018-07-23",
                "round": "Early Stage VC",
                "amount": 0,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 7,
                "lead_investor": ""
          },
          {
                "date": "2020-12-01",
                "round": "Series A",
                "amount": 15000000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 14,
                "lead_investor": "Pantera Capital"
          },
          {
                "date": "2022-04-15",
                "round": "Series B",
                "amount": 70000000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 18,
                "lead_investor": "Pantera Capital"
          },
          {
                "date": "2024-02-01",
                "round": "Later Stage VC",
                "amount": 0,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 6,
                "lead_investor": ""
          }
    ],
    
    cap_table: {},
    
    investors: [
          {
                "name": "Blockchain Ventures Hub",
                "firm": "Blockchain Ventures Hub",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2024-02-01",
                "pitchbook_id": "862776-01"
          },
          {
                "name": "Digital Strategies",
                "firm": "Digital Strategies",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2024-02-01",
                "pitchbook_id": "268246-63"
          },
          {
                "name": "Embedding VC",
                "firm": "Embedding VC",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2024-02-01",
                "pitchbook_id": "541079-83"
          },
          {
                "name": "Limitless Crypto Investments",
                "firm": "Limitless Crypto Investments",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2024-02-01",
                "pitchbook_id": "435853-63"
          },
          {
                "name": "Marshland Capital",
                "firm": "Marshland Capital",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2024-02-01",
                "pitchbook_id": "465458-50"
          },
          {
                "name": "Numeri Capital",
                "firm": "Numeri Capital",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2024-02-01",
                "pitchbook_id": "534922-12"
          },
          {
                "name": "A.Capital Ventures",
                "firm": "A.Capital Ventures",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "118725-85"
          },
          {
                "name": "Atlas Benjelloun",
                "firm": "Atlas Benjelloun",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "518257-27"
          },
          {
                "name": "Ault Krug Partners",
                "firm": "Ault Krug Partners",
                "status": "Lead Investor",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "532513-09"
          },
          {
                "name": "Blockwall Management",
                "firm": "Blockwall Management",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "235053-73"
          },
          {
                "name": "Brevan Howard Asset Management",
                "firm": "Brevan Howard Asset Management",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "84034-54"
          },
          {
                "name": "Continue Capital",
                "firm": "Continue Capital",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "230148-37"
          },
          {
                "name": "Cyberight Capital",
                "firm": "Cyberight Capital",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "482269-33"
          },
          {
                "name": "Framework Ventures",
                "firm": "Framework Ventures",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "436693-24"
          },
          {
                "name": "Greylock",
                "firm": "Greylock",
                "status": "Lead Investor",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "11191-96"
          },
          {
                "name": "GSR",
                "firm": "GSR",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "279816-67"
          },
          {
                "name": "Jared Leto",
                "firm": "Jared Leto",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "105876-55"
          },
          {
                "name": "Jump Crypto",
                "firm": "Jump Crypto",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "489999-25"
          },
          {
                "name": "Nascent",
                "firm": "Nascent",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "462735-73"
          },
          {
                "name": "OpenSea",
                "firm": "OpenSea",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "226883-35"
          },
          {
                "name": "Reid Hoffman",
                "firm": "Reid Hoffman",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "105945-22"
          },
          {
                "name": "Sound Ventures",
                "firm": "Sound Ventures",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-04-15",
                "pitchbook_id": "110390-41"
          },
          {
                "name": "Alliance (Accelerator)",
                "firm": "Alliance (Accelerator)",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "443065-42"
          },
          {
                "name": "Astronaut Capital",
                "firm": "Astronaut Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "436005-82"
          },
          {
                "name": "Block0",
                "firm": "Block0",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "455804-74"
          },
          {
                "name": "Blockchain Ventures (CVC)",
                "firm": "Blockchain Ventures (CVC)",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "466186-06"
          },
          {
                "name": "Bossa Invest",
                "firm": "Bossa Invest",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "82766-89"
          },
          {
                "name": "Coinbase Ventures",
                "firm": "Coinbase Ventures",
                "rounds": [
                      "Series A",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "234449-20"
          },
          {
                "name": "Genblock Capital",
                "firm": "Genblock Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "232193-35"
          },
          {
                "name": "Infinite Capital (San Juan)",
                "firm": "Infinite Capital (San Juan)",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "55348-39"
          },
          {
                "name": "IOSG Ventures",
                "firm": "IOSG Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "339873-94"
          },
          {
                "name": "Jump Capital",
                "firm": "Jump Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "56144-62"
          },
          {
                "name": "Moonwhale Ventures",
                "firm": "Moonwhale Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "265646-17"
          },
          {
                "name": "Nima Capital",
                "firm": "Nima Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-12-01",
                "pitchbook_id": "124315-39"
          },
          {
                "name": "Boost VC",
                "firm": "Boost VC",
                "rounds": [
                      "Early Stage VC"
                ],
                "stake": "Minority",
                "since": "2018-07-23",
                "pitchbook_id": "57017-26"
          },
          {
                "name": "Coinix",
                "firm": "Coinix",
                "rounds": [
                      "Early Stage VC"
                ],
                "stake": "Minority",
                "since": "2018-07-23",
                "pitchbook_id": "439023-07"
          },
          {
                "name": "Craft Ventures",
                "firm": "Craft Ventures",
                "rounds": [
                      "Early Stage VC"
                ],
                "stake": "Minority",
                "since": "2018-07-23",
                "pitchbook_id": "225318-25"
          },
          {
                "name": "Deeptech Ventures",
                "firm": "Deeptech Ventures",
                "rounds": [
                      "Early Stage VC"
                ],
                "stake": "Minority",
                "since": "2018-07-23",
                "pitchbook_id": "233528-41"
          },
          {
                "name": "Maven 11",
                "firm": "Maven 11",
                "rounds": [
                      "Early Stage VC"
                ],
                "stake": "Minority",
                "since": "2018-07-23",
                "pitchbook_id": "279679-69"
          },
          {
                "name": "Placeholder Venture Capital",
                "firm": "Placeholder Venture Capital",
                "rounds": [
                      "Early Stage VC"
                ],
                "stake": "Minority",
                "since": "2018-07-23",
                "pitchbook_id": "183284-83"
          },
          {
                "name": "Rocketfuel USA",
                "firm": "Rocketfuel USA",
                "rounds": [
                      "Early Stage VC"
                ],
                "stake": "Minority",
                "since": "2018-07-23",
                "pitchbook_id": "436885-93"
          },
          {
                "name": "8 Decimal Capital",
                "firm": "8 Decimal Capital",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "228973-51"
          },
          {
                "name": "Blockchain Capital",
                "firm": "Blockchain Capital",
                "rounds": [
                      "Series A",
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "62119-72"
          },
          {
                "name": "FBG Capital",
                "firm": "FBG Capital",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "222089-23"
          },
          {
                "name": "Hex Capital",
                "firm": "Hex Capital",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "227007-01"
          },
          {
                "name": "Kenetic Capital",
                "firm": "Kenetic Capital",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "169540-75"
          },
          {
                "name": "Kirill Bensonoff",
                "firm": "Kirill Bensonoff",
                "status": "Lead Investor",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "443075-50"
          },
          {
                "name": "Pantera Capital",
                "firm": "Pantera Capital",
                "status": "Lead Investor",
                "rounds": [
                      "Seed",
                      "Series A",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "60945-31"
          },
          {
                "name": "Pascal Capital",
                "firm": "Pascal Capital",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "233262-46"
          },
          {
                "name": "Polychain Capital",
                "firm": "Polychain Capital",
                "status": "Lead Investor",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "168852-52"
          },
          {
                "name": "Stateless Ventures",
                "firm": "Stateless Ventures",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "469758-34"
          },
          {
                "name": "Visary Capital",
                "firm": "Visary Capital",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "233613-46"
          },
          {
                "name": "Working Lab Capital",
                "firm": "Working Lab Capital",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "122272-93"
          },
          {
                "name": "ZMT Capital",
                "firm": "ZMT Capital",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-08-10",
                "pitchbook_id": "184301-65"
          }
    ],
    
    board_members: [],
    
    investments_buy_side: []
  },

  "155056-06": {
    company_id: "155056-06",
    name: "Propel (Financial Software)",
    status: "Active",
    industry: "Financial Software",
    founded: "2014-01-01",
    celebrity_investors: ["Jared Leto"],
    website: "www.propel.app",
    description: "Developer of a mobile finance platform designed to manage benefits and debits side-by-side. The company's platform features the ability to instantly view food stamps, locate grocery stores, corner stores, and farmer markets nearby as well as keep track of spending and receive government benefits such as rental assistance and cash payments to manage those benefits alongside their earned income and their overall finances, enabling individuals with low income to improve their financial health, save money, find jobs and earn income.",
    keywords: ["advertising platform","consumer brands","financial health","food stamping","income data","mobile banking","personal financial management"],
    
    latest_funding: {
      round_type: "Series B",
      date: "2022-02-02",
      amount: 55515246,
      valuation: 520515246,
      post_money_valuation: 520515246,
      lead_investor: "Andreessen Horowitz",
      other_investors: ["345 Partners","Financial Health Network","Jeremy Lin","JP Morgan Chase","Mischief","New York Life Ventures","Salesforce Ventures","Team Ignite Ventures","Flourish Ventures"]
    },
    
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 465000000
    },
    
    team: [
          {
                "name": "Sizhe Chen",
                "role": "Co-Founder & Chief Executive Officer",
                "background": ""
          }
    ],
    
    deal_history: [
          {
                "date": "2015-01-01",
                "round": "Accelerator/Inc",
                "amount": 0,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 1,
                "lead_investor": ""
          },
          {
                "date": "2015-05-15",
                "round": "Accelerator/Inc",
                "amount": 250000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 1,
                "lead_investor": "Financial Solutions Lab"
          },
          {
                "date": "2017-05-10",
                "round": "Seed",
                "amount": 5239945,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 10,
                "lead_investor": "Thirty Five Ventures"
          },
          {
                "date": "2018-12-14",
                "round": "Series A",
                "amount": 12819645,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 7,
                "lead_investor": "Nyca Partners"
          },
          {
                "date": "2020-09-02",
                "round": "Series A1",
                "amount": 16499984,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 6,
                "lead_investor": "Kleiner Perkins"
          },
          {
                "date": "2022-02-02",
                "round": "Series B",
                "amount": 55515246,
                "valuation": 520515246,
                "pre_money_valuation": 0,
                "investors": 13,
                "lead_investor": "Andreessen Horowitz"
          }
    ],
    
    cap_table: {
          "Series B": "10.67",
          "Series A-1": "11.87",
          "Series A": "16.57",
          "Seed": "19.13",
          "Common Stock": "41.76"
    },
    
    investors: [
          {
                "name": "345 Partners",
                "firm": "345 Partners",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-02-02",
                "pitchbook_id": "342134-47"
          },
          {
                "name": "Financial Health Network",
                "firm": "Financial Health Network",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-02-02",
                "pitchbook_id": "10352-89"
          },
          {
                "name": "Jared Leto",
                "firm": "Jared Leto",
                "status": "Lead Investor",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-02-02",
                "pitchbook_id": "105876-55"
          },
          {
                "name": "Jeremy Lin",
                "firm": "Jeremy Lin",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-02-02",
                "pitchbook_id": "170653-15"
          },
          {
                "name": "JP Morgan Chase",
                "firm": "JP Morgan Chase",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-02-02",
                "pitchbook_id": "55545-67"
          },
          {
                "name": "Mischief",
                "firm": "Mischief",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-02-02",
                "pitchbook_id": "466475-14"
          },
          {
                "name": "New York Life Ventures",
                "firm": "New York Life Ventures",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-02-02",
                "pitchbook_id": "224392-60"
          },
          {
                "name": "Salesforce Ventures",
                "firm": "Salesforce Ventures",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-02-02",
                "pitchbook_id": "107882-74"
          },
          {
                "name": "Team Ignite Ventures",
                "firm": "Team Ignite Ventures",
                "rounds": [
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2022-02-02",
                "pitchbook_id": "513327-34"
          },
          {
                "name": "CLF Partners",
                "firm": "CLF Partners",
                "rounds": [
                      "Series A1"
                ],
                "stake": "Minority",
                "since": "2020-09-02",
                "pitchbook_id": "232535-17"
          },
          {
                "name": "Flourish Ventures",
                "firm": "Flourish Ventures",
                "rounds": [
                      "Series A1",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2020-09-02",
                "pitchbook_id": "267182-65"
          },
          {
                "name": "Inspired Capital (New York)",
                "firm": "Inspired Capital (New York)",
                "rounds": [
                      "Series A1"
                ],
                "stake": "Minority",
                "since": "2020-09-02",
                "pitchbook_id": "266110-03"
          },
          {
                "name": "Kevin Durant",
                "firm": "Kevin Durant",
                "status": "Lead Investor",
                "rounds": [
                      "Series A1"
                ],
                "stake": "Minority",
                "since": "2020-09-02",
                "pitchbook_id": "166439-35"
          },
          {
                "name": "Serena Ventures",
                "firm": "Serena Ventures",
                "status": "Lead Investor",
                "rounds": [
                      "Series A1"
                ],
                "stake": "Minority",
                "since": "2020-09-02",
                "pitchbook_id": "266573-17"
          },
          {
                "name": "Alexa von Tobel",
                "firm": "Alexa von Tobel",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2018-12-14",
                "pitchbook_id": "232480-00"
          },
          {
                "name": "Kleiner Perkins",
                "firm": "Kleiner Perkins",
                "status": "Lead Investor",
                "rounds": [
                      "Series B",
                      "Series A1",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2018-12-14",
                "pitchbook_id": "11228-50"
          },
          {
                "name": "Nyca Partners",
                "firm": "Nyca Partners",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2018-12-14",
                "pitchbook_id": "62138-71"
          },
          {
                "name": "Restive Ventures",
                "firm": "Restive Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2018-12-14",
                "pitchbook_id": "229762-63"
          },
          {
                "name": "Andreessen Horowitz",
                "firm": "Andreessen Horowitz",
                "status": "Lead Investor",
                "rounds": [
                      "Seed",
                      "Series A",
                      "Series B"
                ],
                "stake": "Minority",
                "since": "2017-05-10",
                "pitchbook_id": "41716-90"
          },
          {
                "name": "Jay Borenstein",
                "firm": "Jay Borenstein",
                "status": "Lead Investor",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-05-10",
                "pitchbook_id": "180341-74"
          },
          {
                "name": "Max Levchin",
                "firm": "Max Levchin",
                "status": "Lead Investor",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-05-10",
                "pitchbook_id": "106019-47"
          },
          {
                "name": "Nasir Jones",
                "firm": "Nasir Jones",
                "status": "Lead Investor",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-05-10",
                "pitchbook_id": "107825-23"
          },
          {
                "name": "Omidyar Network",
                "firm": "Omidyar Network",
                "rounds": [
                      "Series A",
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-05-10",
                "pitchbook_id": "11262-16"
          },
          {
                "name": "Omidyar Technology Ventures",
                "firm": "Omidyar Technology Ventures",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-05-10",
                "pitchbook_id": "188017-21"
          },
          {
                "name": "SciFi VC",
                "firm": "SciFi VC",
                "status": "Lead Investor",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-05-10",
                "pitchbook_id": "169461-64"
          },
          {
                "name": "Thirty Five Ventures",
                "firm": "Thirty Five Ventures",
                "status": "Lead Investor",
                "rounds": [
                      "Seed"
                ],
                "stake": "Minority",
                "since": "2017-05-10",
                "pitchbook_id": "234080-11"
          },
          {
                "name": "Winwin",
                "firm": "Winwin",
                "rounds": [
                      "Seed",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2017-05-10",
                "pitchbook_id": "180341-92"
          },
          {
                "name": "Financial Solutions Lab",
                "firm": "Financial Solutions Lab",
                "status": "Lead Investor",
                "rounds": [
                      "Seed",
                      "Accelerator/Inc"
                ],
                "stake": "Minority",
                "since": "2015-05-15",
                "pitchbook_id": "155035-36"
          },
          {
                "name": "Village Capital",
                "firm": "Village Capital",
                "rounds": [
                      "Accelerator/Inc"
                ],
                "stake": "Minority",
                "since": "2015-01-01",
                "pitchbook_id": "56089-63"
          },
          {
                "name": "Blue Ridge Labs",
                "firm": "Blue Ridge Labs",
                "rounds": [
                      "Accelerator/Inc"
                ],
                "stake": "Minority",
                "pitchbook_id": "64818-19"
          },
          {
                "name": "GoodCompany Ventures",
                "firm": "GoodCompany Ventures",
                "rounds": [
                      "Accelerator/Inc"
                ],
                "stake": "Minority",
                "pitchbook_id": "169736-23"
          }
    ],
    
    board_members: [],
    
    investments_buy_side: []
  },

  "233790-67": {
    company_id: "233790-67",
    name: "Superplastic",
    status: "Active",
    industry: "Recreational Goods",
    founded: "2017-01-01",
    celebrity_investors: ["Jared Leto"],
    website: "www.superplastic.co",
    description: "Operator of a synthetic entertainment company intended to create the first synthetic superstars. The company's platform offers a variety of media superstars, including animated videos, music, fashion, and gaming, enabling customers to engage with their favorite characters in new and innovative ways.",
    keywords: ["designer toy platform","digital concepts","global entertainment","kids toys","metaverse character","toy manufacturer"],
    
    latest_funding: {
      round_type: "Series A",
      date: "2021-10-20",
      amount: 19999994,
      valuation: 157999999,
      post_money_valuation: 157999999,
      lead_investor: "Scott Belsky",
      other_investors: ["1/1 Capital","32 Ventures","75 & Sunny","Animoca Brands","Aria Emiko (Investment)","Day One Ventures","Galaxy Digital (New York)","Hanfield Venture Partners","Highfield Capital","I2BF Global Ventures","IPX ( Business/Productivity Software)","Kakao Entertainment","Mana Ventures","Riverside Ventures","Sony Music Entertainment (Japan)","Spacecadet Ventures","Trac (San Francisco)","Galaxy Interactive","GV","Mantis VC","The Chainsmokers","Betaworks Ventures","Index Ventures"]
    },
    
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 138000005
    },
    
    team: [
          {
                "name": "Paul Budnitz",
                "role": "Co-Founder & Co-Chief Executive Officer",
                "background": ""
          }
    ],
    
    deal_history: [
          {
                "date": "2018-01-01",
                "round": "Series A",
                "amount": 0,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 1,
                "lead_investor": "Craft Ventures"
          },
          {
                "date": "2019-07-30",
                "round": "Series A",
                "amount": 10000000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 15,
                "lead_investor": "Weekend Fund"
          },
          {
                "date": "2020-10-22",
                "round": "Series A",
                "amount": 5999999,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 11,
                "lead_investor": "Scott Belsky"
          },
          {
                "date": "2021-10-20",
                "round": "Series A",
                "amount": 19999994,
                "valuation": 157999999,
                "pre_money_valuation": 0,
                "investors": 32,
                "lead_investor": "Scott Belsky"
          },
          {
                "date": "2022-04-30",
                "round": "Later Stage VC",
                "amount": 24000000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 12,
                "lead_investor": "TLF Ventures"
          },
          {
                "date": "2023-02-16",
                "round": "Series A",
                "amount": 20000000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 19,
                "lead_investor": "Craft Ventures"
          }
    ],
    
    cap_table: {
          "Series A-3": "12.66",
          "Series A-7": "0.80",
          "Series A-6": "0.52",
          "Series A-5": "8.73",
          "Series A-4": "1.59",
          "Series A-2": "12.36",
          "Series A-1": "4.90",
          "Series A": "16.95",
          "Common Stock": "41.49"
    },
    
    investors: [
          {
                "name": "Block.one",
                "firm": "Block.one",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-02-16",
                "pitchbook_id": "183309-58"
          },
          {
                "name": "Kearny Jackson",
                "firm": "Kearny Jackson",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-02-16",
                "pitchbook_id": "234169-21"
          },
          {
                "name": "Native Crypto (Investor)",
                "firm": "Native Crypto (Investor)",
                "rounds": [
                      "Series A"
                ],
                "since": "2023-02-16",
                "pitchbook_id": "588709-09"
          },
          {
                "name": "Nomu Ventures",
                "firm": "Nomu Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-02-16",
                "pitchbook_id": "432489-43"
          },
          {
                "name": "Realm Capital Ventures",
                "firm": "Realm Capital Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-02-16",
                "pitchbook_id": "529167-97"
          },
          {
                "name": "WAGMI Ventures (Texas)",
                "firm": "WAGMI Ventures (Texas)",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-02-16",
                "pitchbook_id": "535961-62"
          },
          {
                "name": "Wejchert Capital",
                "firm": "Wejchert Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-02-16",
                "pitchbook_id": "521409-70"
          },
          {
                "name": "XRM Media",
                "firm": "XRM Media",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2023-02-16",
                "pitchbook_id": "268461-73"
          },
          {
                "name": "Amazon Alexa Fund",
                "firm": "Amazon Alexa Fund",
                "status": "Lead Investor",
                "rounds": [
                      "Later Stage VC",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "184557-16"
          },
          {
                "name": "Atacama Ventures",
                "firm": "Atacama Ventures",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "122870-26"
          },
          {
                "name": "Browder Capital",
                "firm": "Browder Capital",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "471089-17"
          },
          {
                "name": "Kering",
                "firm": "Kering",
                "rounds": [
                      "Series A",
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "60413-50"
          },
          {
                "name": "Scribble Ventures",
                "firm": "Scribble Ventures",
                "rounds": [
                      "Series A",
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "438080-68"
          },
          {
                "name": "Sony",
                "firm": "Sony",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "59614-93"
          },
          {
                "name": "SV Pacific Ventures",
                "firm": "SV Pacific Ventures",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "483225-13"
          },
          {
                "name": "The Emprise Group",
                "firm": "The Emprise Group",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "434933-38"
          },
          {
                "name": "Tiny Capital",
                "firm": "Tiny Capital",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "150628-51"
          },
          {
                "name": "TLF Ventures",
                "firm": "TLF Ventures",
                "status": "Lead Investor",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "221468-41"
          },
          {
                "name": "Z Venture Capital",
                "firm": "Z Venture Capital",
                "rounds": [
                      "Later Stage VC"
                ],
                "stake": "Minority",
                "since": "2022-04-30",
                "pitchbook_id": "463972-69"
          },
          {
                "name": "1/1 Capital",
                "firm": "1/1 Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "489217-87"
          },
          {
                "name": "32 Ventures",
                "firm": "32 Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "251510-68"
          },
          {
                "name": "75 & Sunny",
                "firm": "75 & Sunny",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "465765-67"
          },
          {
                "name": "Alan Curtis",
                "firm": "Alan Curtis",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "494028-82"
          },
          {
                "name": "Animoca Brands",
                "firm": "Animoca Brands",
                "rounds": [
                      "Later Stage VC",
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "65039-59"
          },
          {
                "name": "Aria Emiko (Investment)",
                "firm": "Aria Emiko (Investment)",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "472489-84"
          },
          {
                "name": "Austin Walker",
                "firm": "Austin Walker",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "472263-31"
          },
          {
                "name": "Cyan Bannister",
                "firm": "Cyan Bannister",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "108127-81"
          },
          {
                "name": "Day One Ventures",
                "firm": "Day One Ventures",
                "rounds": [
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "91046-62"
          },
          {
                "name": "Galaxy Digital (New York)",
                "firm": "Galaxy Digital (New York)",
                "rounds": [
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "185138-74"
          },
          {
                "name": "Hanfield Venture Partners",
                "firm": "Hanfield Venture Partners",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "483201-91"
          },
          {
                "name": "Highfield Capital",
                "firm": "Highfield Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "504035-74"
          },
          {
                "name": "I2BF Global Ventures",
                "firm": "I2BF Global Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "42864-40"
          },
          {
                "name": "IPX ( Business/Productivity Software)",
                "firm": "IPX ( Business/Productivity Software)",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "436391-11"
          },
          {
                "name": "Jared Leto",
                "firm": "Jared Leto",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "105876-55"
          },
          {
                "name": "Kakao Entertainment",
                "firm": "Kakao Entertainment",
                "rounds": [
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "88550-56"
          },
          {
                "name": "Mana Ventures",
                "firm": "Mana Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "187876-90"
          },
          {
                "name": "Riverside Ventures",
                "firm": "Riverside Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "300219-22"
          },
          {
                "name": "Sam Rosenbaum",
                "firm": "Sam Rosenbaum",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "481990-33"
          },
          {
                "name": "Sony Music Entertainment (Japan)",
                "firm": "Sony Music Entertainment (Japan)",
                "rounds": [
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "228738-61"
          },
          {
                "name": "Spacecadet Ventures",
                "firm": "Spacecadet Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "465548-32"
          },
          {
                "name": "Trac (San Francisco)",
                "firm": "Trac (San Francisco)",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "433201-69"
          },
          {
                "name": "Wiz Wiz",
                "firm": "Wiz Wiz",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2021-10-20",
                "pitchbook_id": "458365-33"
          },
          {
                "name": "Esalen Ventures",
                "firm": "Esalen Ventures",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-10-22",
                "pitchbook_id": "465274-63"
          },
          {
                "name": "Gaingels",
                "firm": "Gaingels",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-10-22",
                "pitchbook_id": "124929-82"
          },
          {
                "name": "Galaxy Interactive",
                "firm": "Galaxy Interactive",
                "rounds": [
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-10-22",
                "pitchbook_id": "432704-26"
          },
          {
                "name": "GV",
                "firm": "GV",
                "rounds": [
                      "Series A",
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-10-22",
                "pitchbook_id": "49063-60"
          },
          {
                "name": "Justin Timberlake",
                "firm": "Justin Timberlake",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-10-22",
                "pitchbook_id": "106214-41"
          },
          {
                "name": "Mantis VC",
                "firm": "Mantis VC",
                "rounds": [
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-10-22",
                "pitchbook_id": "431348-32"
          },
          {
                "name": "Noveus Capital",
                "firm": "Noveus Capital",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-10-22",
                "pitchbook_id": "435504-88"
          },
          {
                "name": "The Chainsmokers",
                "firm": "The Chainsmokers",
                "rounds": [
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2020-10-22",
                "pitchbook_id": "438008-32"
          },
          {
                "name": "Betaworks Ventures",
                "firm": "Betaworks Ventures",
                "rounds": [
                      "Series A",
                      "Series A",
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "233125-48"
          },
          {
                "name": "Canaan Partners",
                "firm": "Canaan Partners",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "11135-71"
          },
          {
                "name": "Cyan Banister",
                "firm": "Cyan Banister",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "106060-60"
          },
          {
                "name": "Evolution VC Partners",
                "firm": "Evolution VC Partners",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "183656-44"
          },
          {
                "name": "Founders Fund",
                "firm": "Founders Fund",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "11315-62"
          },
          {
                "name": "Index Ventures",
                "firm": "Index Ventures",
                "rounds": [
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "11216-98"
          },
          {
                "name": "Kevin Weil",
                "firm": "Kevin Weil",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "152815-78"
          },
          {
                "name": "Proton Enterprises",
                "firm": "Proton Enterprises",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "62299-09"
          },
          {
                "name": "Saltwater Capital",
                "firm": "Saltwater Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "227537-56"
          },
          {
                "name": "Scooter Braun",
                "firm": "Scooter Braun",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "106326-55"
          },
          {
                "name": "Scott Belsky",
                "firm": "Scott Belsky",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "106022-53"
          },
          {
                "name": "Shrug Capital",
                "firm": "Shrug Capital",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "227750-86"
          },
          {
                "name": "Village Global",
                "firm": "Village Global",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "187442-38"
          },
          {
                "name": "Weekend Fund",
                "firm": "Weekend Fund",
                "status": "Lead Investor",
                "rounds": [
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2019-07-30",
                "pitchbook_id": "343304-47"
          },
          {
                "name": "Craft Ventures",
                "firm": "Craft Ventures",
                "status": "Lead Investor",
                "rounds": [
                      "Series A",
                      "Series A",
                      "Series A"
                ],
                "stake": "Minority",
                "since": "2018-01-01",
                "pitchbook_id": "225318-25"
          }
    ],
    
    board_members: [],
    
    investments_buy_side: []
  },

  "439120-90": {
    company_id: "439120-90",
    name: "X1 Card",
    status: "Exited",
    industry: "Other Financial Services",
    founded: "2017-01-01",
    celebrity_investors: ["Jared Leto"],
    website: "www.x1creditcard.com",
    description: "Provider of credit cards and financial services intended for shopping and other electronic purchases. The company provides stainless steel credit cards that have various automated features and reward programs as well as a point system for every purchase that can be redeemed later, enabling credit cardholders to transform the way they shop.",
    keywords: ["bnpl","credit & bnpl","credit and banking","credit card","credit shopping","digital card","financial services","fintech firm","smart credit card"],
    
    latest_funding: {
      round_type: "Series B",
      date: "2022-12-01",
      amount: 40000000,
      valuation: 200000000,
      post_money_valuation: 200000000,
      lead_investor: "",
      other_investors: []
    },
    
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 160000000
    },
    
    team: [],
    
    deal_history: [
          {
                "date": "2022-12-01",
                "round": "Series B",
                "amount": 40000000,
                "valuation": 200000000,
                "pre_money_valuation": 0,
                "investors": 0,
                "lead_investor": ""
          }
    ],
    
    cap_table: {},
    
    investors: [],
    
    board_members: [],
    
    investments_buy_side: [],
    
    exit_info: {
          "exit_type": "Merger/Acquisition",
          "exit_date": "2023-06-22",
          "acquirer": "",
          "exit_value": 0
    }
  },

  "266180-68": {
    company_id: "266180-68",
    name: "Rupa Health",
    status: "Exited",
    industry: "Other Healthcare Technology Systems",
    founded: "2018-01-01",
    celebrity_investors: ["Jared Leto"],
    website: "www.rupahealth.com",
    description: "Developer and operator of a web-based lab portal intended to assist doctors with ordering specialty lab work, handling samples, and delivering results. The company's platform processes the entire labwork experience from beginning to end with no membership, no subscription, and discounted wholesale prices for their patients for a service fee, enabling healthcare professionals to order multiple tests from different lab companies in a single place.",
    keywords: ["healthcare marketplace","lab supplies","laboratory platform","laboratory service","medical marketplace","telehealth care"],
    
    latest_funding: {
      round_type: "Series A",
      date: "2022-03-01",
      amount: 19875044,
      valuation: 98000003,
      post_money_valuation: 98000003,
      lead_investor: "Union Square Ventures",
      other_investors: []
    },
    
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 78124959
    },
    
    team: [
          {
                "name": "Rosa Hamalainen",
                "role": "Co-Founder and Head of Strategic Initiatives, Products and Operations",
                "background": ""
          }
    ],
    
    deal_history: [
          {
                "date": "2022-03-01",
                "round": "Series A",
                "amount": 19875044,
                "valuation": 98000003,
                "pre_money_valuation": 0,
                "investors": 0,
                "lead_investor": ""
          },
          {
                "date": "2022-08-29",
                "round": "Series A1",
                "amount": 18512409,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 1,
                "lead_investor": ""
          }
    ],
    
    cap_table: {
          "Series A1": "9.26",
          "Series A": "17.96",
          "Seed-6": "16.10",
          "Seed-5": "1.59",
          "Seed-4": "0.42",
          "Seed-3": "0.16",
          "Seed-2": "0.75",
          "Seed-1": "3.55",
          "Common Stock": "50.21"
    },
    
    investors: [
          {
                "name": "Union Square Ventures",
                "firm": "Union Square Ventures",
                "rounds": [
                      "Series A1"
                ],
                "stake": "Minority",
                "since": "2022-08-29",
                "pitchbook_id": "11323-45"
          },
          {
                "name": "Fintech Next",
                "firm": "Fintech Next",
                "rounds": [
                      "Accelerator/Inc"
                ],
                "pitchbook_id": "471886-66"
          }
    ],
    
    board_members: [],
    
    investments_buy_side: [],
    
    exit_info: {
          "exit_type": "Buyout/LBO (Add-on)",
          "exit_date": "2024-10-08",
          "acquirer": "",
          "exit_value": 0
    }
  },

  "102075-04": {
    company_id: "102075-04",
    name: "Relativity Space",
    status: "Exited",
    industry: "Aerospace and Defense",
    founded: "2015-01-01",
    celebrity_investors: ["Jared Leto"],
    website: "www.relativityspace.com",
    description: "Operator of an aerospace design and manufacturing company intended to offer commercial launch services. The company creates reusable rockets by leveraging 3D printing technology and an iterative development approach for reducing vehicle complexity, cost, and time to market, enabling clients to have access to the right size payload capacity at suitable costs.",
    keywords: ["additives manufacturing","aerospace company","autonomous robotics software","launch vehicle","satellite launching systems","space economy"],
    
    latest_funding: {
      round_type: "Series E",
      date: "2021-06-08",
      amount: 650000003,
      valuation: 4150000015,
      post_money_valuation: 4150000015,
      lead_investor: "Winklevoss Capital Management",
      other_investors: ["K5 Global"]
    },
    
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 3500000012
    },
    
    team: [
          {
                "name": "Timothy Ellis",
                "role": "Co-Founder and Board Member",
                "background": ""
          }
    ],
    
    deal_history: [
          {
                "date": "2019-10-01",
                "round": "Series C",
                "amount": 139999999,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 1,
                "lead_investor": ""
          },
          {
                "date": "2020-11-23",
                "round": "Series D",
                "amount": 500000007,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 2,
                "lead_investor": ""
          },
          {
                "date": "2021-06-08",
                "round": "Series E",
                "amount": 650000003,
                "valuation": 4150000015,
                "pre_money_valuation": 0,
                "investors": 1,
                "lead_investor": ""
          },
          {
                "date": "2023-11-14",
                "round": "Series F",
                "amount": 1049000000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 2,
                "lead_investor": ""
          }
    ],
    
    cap_table: {
          "Series F": "9.90",
          "Series E": "6.09",
          "Series D": "7.16",
          "Series C": "8.67",
          "Series B": "5.84",
          "Series A": "2.49",
          "SAFE": "0.04",
          "Seed": "0.59",
          "Common Stock": "59.22"
    },
    
    investors: [
          {
                "name": "Winklevoss Capital Management",
                "firm": "Winklevoss Capital Management",
                "rounds": [
                      "Series F"
                ],
                "stake": "Minority",
                "since": "2023-11-14",
                "pitchbook_id": "55254-79"
          },
          {
                "name": "Matterhorn Studio(VC)",
                "firm": "Matterhorn Studio(VC)",
                "rounds": [
                      "Series D"
                ],
                "stake": "Minority",
                "since": "2020-11-23",
                "pitchbook_id": "769488-13"
          },
          {
                "name": "K5 Global",
                "firm": "K5 Global",
                "rounds": [
                      "Series D",
                      "Series E",
                      "Series C",
                      "Series F"
                ],
                "stake": "Minority",
                "since": "2019-10-01",
                "pitchbook_id": "343248-58"
          }
    ],
    
    board_members: [],
    
    investments_buy_side: [],
    
    exit_info: {
          "exit_type": "Merger/Acquisition",
          "exit_date": "2025-03-11",
          "acquirer": "",
          "exit_value": 0
    }
  },

  "63828-10": {
    company_id: "63828-10",
    name: "PayRange",
    status: "Exited",
    industry: "Financial Software",
    founded: "2013-01-01",
    celebrity_investors: ["Jared Leto"],
    website: "www.payrange.com",
    description: "Developer of an end-to-end IOT platform designed to automate the retail industry. The company's software can be installed inside laundry, vending, and amusement machines and uses the consumer's smartphone for connectivity and payment, enabling customers to make payments cost-effectively and in an easy-to-use manner.",
    keywords: ["customer relationship management","digital commerce","enterprise payment","mobile payment","mobile payment technology","payment application","payment facilitation","payment platform","payment technology"],
    
    latest_funding: {
      round_type: "Seed",
      date: "2014-08-14",
      amount: 2582045,
      valuation: 16600970,
      post_money_valuation: 16600970,
      lead_investor: "Bain Capital Credit",
      other_investors: []
    },
    
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 14018925
    },
    
    team: [
          {
                "name": "Paresh Patel",
                "role": "Founder & Chief Executive Officer",
                "background": ""
          }
    ],
    
    deal_history: [
          {
                "date": "2014-08-14",
                "round": "Seed",
                "amount": 2582045,
                "valuation": 16600970,
                "pre_money_valuation": 0,
                "investors": 0,
                "lead_investor": ""
          },
          {
                "date": "2024-09-30",
                "round": "Buyout/LBO",
                "amount": 0,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 3,
                "lead_investor": "Ridgeview Partners"
          },
          {
                "date": "2024-10-31",
                "round": "Debt",
                "amount": 22669000,
                "valuation": 0,
                "pre_money_valuation": 0,
                "investors": 1,
                "lead_investor": ""
          }
    ],
    
    cap_table: {
          "Series A-1": "14.25",
          "Series A": "16.35",
          "Seed": "8.61",
          "Common Stock": "60.79"
    },
    
    investors: [
          {
                "name": "Bain Capital Credit",
                "firm": "Bain Capital Credit",
                "rounds": [
                      "Debt"
                ],
                "stake": "Minority",
                "since": "2024-10-31",
                "pitchbook_id": "10397-17"
          },
          {
                "name": "Northleaf Capital Partners",
                "firm": "Northleaf Capital Partners",
                "rounds": [
                      "Buyout/LBO"
                ],
                "stake": "Minority",
                "since": "2024-09-30",
                "pitchbook_id": "10072-09"
          },
          {
                "name": "Ridgeview Partners",
                "firm": "Ridgeview Partners",
                "status": "Lead Investor",
                "rounds": [
                      "Buyout/LBO"
                ],
                "stake": "Majority",
                "since": "2024-09-30",
                "pitchbook_id": "559670-23"
          },
          {
                "name": "The Baupost Group",
                "firm": "The Baupost Group",
                "rounds": [
                      "Buyout/LBO"
                ],
                "stake": "Minority",
                "since": "2024-09-30",
                "pitchbook_id": "42265-54"
          }
    ],
    
    board_members: [],
    
    investments_buy_side: [],
    
    exit_info: {
          "exit_type": "Buyout/LBO",
          "exit_date": "2024-09-30",
          "acquirer": "",
          "exit_value": 0
    }
  }


,

  "0": {
    company_id: "719403-94",
    name: "Aetherflux",
    industry: "Aerospace and Defense",
    status: "Active",
    celebrity_investors: [
      "Jared Leto"
    ],
    latest_round: "Series A",
    latest_round_date: "2025-04-02"
  },

  "1": {
    company_id: "608847-76",
    name: "Harmonic (Educational Software)",
    industry: "Educational Software",
    status: "Active",
    celebrity_investors: [
      "Jared Leto"
    ],
    latest_round: "Series A",
    latest_round_date: "2024-09-23"
  },

  "2": {
    company_id: "537093-55",
    name: "Pika (Multimedia and Design Software)",
    industry: "Multimedia and Design Software",
    status: "Active",
    celebrity_investors: [
      "Jared Leto"
    ],
    latest_round: "Series B",
    latest_round_date: "2024-07-23"
  },

  "3": {
    company_id: "183309-13",
    name: "ZeroEx (San Francisco)",
    industry: "Financial Software",
    status: "Active",
    celebrity_investors: [
      "Jared Leto"
    ],
    latest_round: "Series B",
    latest_round_date: "2022-04-15"
  },

  "4": {
    company_id: "155056-06",
    name: "Propel (Financial Software)",
    industry: "Financial Software",
    status: "Active",
    celebrity_investors: [
      "Jared Leto"
    ],
    latest_round: "Series B",
    latest_round_date: "2022-02-02"
  },

  "5": {
    company_id: "233790-67",
    name: "Superplastic",
    industry: "Recreational Goods",
    status: "Active",
    celebrity_investors: [
      "Jared Leto"
    ],
    latest_round: "Series A",
    latest_round_date: "2021-10-20"
  },

  "6": {
    company_id: "439120-90",
    name: "X1 Card",
    industry: "Other Financial Services",
    status: "Exited",
    celebrity_investors: [
      "Jared Leto"
    ],
    latest_round: "Series B",
    latest_round_date: "2022-12-01"
  },

  "7": {
    company_id: "266180-68",
    name: "Rupa Health",
    industry: "Other Healthcare Technology Systems",
    status: "Exited",
    celebrity_investors: [
      "Jared Leto"
    ],
    latest_round: "Series A",
    latest_round_date: "2022-03-01"
  },

  "8": {
    company_id: "102075-04",
    name: "Relativity Space",
    industry: "Aerospace and Defense",
    status: "Exited",
    celebrity_investors: [
      "Jared Leto"
    ],
    latest_round: "Series E",
    latest_round_date: "2021-06-08"
  },

  "9": {
    company_id: "439120-90",
    name: "X1 Card",
    industry: "Other Financial Services",
    status: "Exited",
    celebrity_investors: [
      "Jared Leto"
    ],
    latest_round: "Early Stage VC",
    latest_round_date: "2021-01-14"
  }
,

  "506937-88": {
    company_id: "506937-88",
    name: "TMRW Sports",
    status: "Active",
    industry: "Publishing",
    founded: "2021-04-01",
    celebrity_investors: [
      "Justin Bieber"
    ],
    website: "www.tmrwsportsgroup.com",
    description: "Operator of a sports media and technology platform intended to bring golf and other related sports services to customers. The company's platform launches golf leagues and holds a series of stadium events, enabling customers to get progressive approaches to sports, media, and entertainment from around the world.",
    keywords: [
      "golf community",
      "golf league",
      "online sports media",
      "sports media",
      "sports media news",
      "sports team",
      "sports technology"
    ],
    latest_funding: {
      round_type: "Early Stage VC",
      date: "2023-03-21",
      amount: 15000000,
      valuation: 0,
      post_money_valuation: 0,
      lead_investor: "Trea Turner",
      other_investors: [
        "25madison",
        "Apex Capital (Portugal)",
        "AyBe",
        "Fenway Sports Group",
        "First Serve Partners",
        "Michael Rubin",
        "NewBound Venture Capital",
        "Seven Seven Six",
        "Shaquille O'Neal",
        "Symphony Ventures (Ireland)",
        "Thirty Five Ventures",
        "Tiger Woods Ventures",
        "Will Ventures"
      ]
    },
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 0
    },
    team: [
      {
        name: "Katie Fitzpatrick",
        role: "Chief Financial Officer & Vice President",
        background: ""
      }
    ],
    deal_history: [
      {
        date: "2023-03-21",
        round: "Early Stage VC",
        amount: 15000000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 43,
        lead_investor: "Trea Turner"
      },
      {
        date: "2024-06-24",
        round: "Series A",
        amount: 0,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 61,
        lead_investor: "Mike Trout"
      }
    ],
    cap_table: {},
    investors: [
      {
        name: "32 Ventures",
        firm: "32 Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "251510-68"
      },
      {
        name: "Ackerley Sports Group",
        firm: "Ackerley Sports Group",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606950-65"
      },
      {
        name: "Anthony Jabbour",
        firm: "Anthony Jabbour",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606962-44"
      },
      {
        name: "Arthur Blank",
        firm: "Arthur Blank",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606954-25"
      },
      {
        name: "Cal Crutchlow",
        firm: "Cal Crutchlow",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606962-89"
      },
      {
        name: "Carolyn Blodgett",
        firm: "Carolyn Blodgett",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606954-34"
      },
      {
        name: "Cartan Capital",
        firm: "Cartan Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "544874-05"
      },
      {
        name: "David Arison",
        firm: "David Arison",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "342102-07"
      },
      {
        name: "David Blitzer",
        firm: "David Blitzer",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "113097-16"
      },
      {
        name: "Derek Jeter",
        firm: "Derek Jeter",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "106222-42"
      },
      {
        name: "Dynasty Equity",
        firm: "Dynasty Equity",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "503981-20"
      },
      {
        name: "Eric Lane",
        firm: "Eric Lane",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606962-62"
      },
      {
        name: "Gary Burnison",
        firm: "Gary Burnison",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606954-43"
      },
      {
        name: "Gary Cohn",
        firm: "Gary Cohn",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "149717-35"
      },
      {
        name: "Greyson Clymer",
        firm: "Greyson Clymer",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606954-52"
      },
      {
        name: "Gross Labs",
        firm: "Gross Labs",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "510129-82"
      },
      {
        name: "Haley Jones",
        firm: "Haley Jones",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606963-16"
      },
      {
        name: "Jay Steinfeld",
        firm: "Jay Steinfeld",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "530475-85"
      },
      {
        name: "John Terry",
        firm: "John Terry",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "494370-37"
      },
      {
        name: "Jonathan Owsley",
        firm: "Jonathan Owsley",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "471401-11"
      },
      {
        name: "Jozy Altidore",
        firm: "Jozy Altidore",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "463378-60"
      },
      {
        name: "JT Realmuto",
        firm: "JT Realmuto",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606963-34"
      },
      {
        name: "Kailash Somani",
        firm: "Kailash Somani",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "268251-58"
      },
      {
        name: "LEAD (Venture Capital)",
        firm: "LEAD (Venture Capital)",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "176117-41"
      },
      {
        name: "Mark Wilf",
        firm: "Mark Wilf",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "571753-45"
      },
      {
        name: "Maurice Edu",
        firm: "Maurice Edu",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "183113-02"
      },
      {
        name: "Metropolitan Capital",
        firm: "Metropolitan Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "52612-57"
      },
      {
        name: "Michael Farello",
        firm: "Michael Farello",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "471401-02"
      },
      {
        name: "Middle West Partners",
        firm: "Middle West Partners",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606962-17"
      },
      {
        name: "Niche Capital (San Francisco)",
        firm: "Niche Capital (San Francisco)",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "597243-61"
      },
      {
        name: "Old Tom Capital",
        firm: "Old Tom Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "616030-39"
      },
      {
        name: "Ollie Pope",
        firm: "Ollie Pope",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606963-25"
      },
      {
        name: "Pat Battle",
        firm: "Pat Battle",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606954-07"
      },
      {
        name: "Patrick Mouratoglou",
        firm: "Patrick Mouratoglou",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "182942-47"
      },
      {
        name: "Present Ventures",
        firm: "Present Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606951-19"
      },
      {
        name: "Ray Evernham",
        firm: "Ray Evernham",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606963-07"
      },
      {
        name: "Redwave Venture Partners",
        firm: "Redwave Venture Partners",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "542371-51"
      },
      {
        name: "Reginald Love",
        firm: "Reginald Love",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "433955-35"
      },
      {
        name: "Robert Greifeld",
        firm: "Robert Greifeld",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606955-06"
      },
      {
        name: "Robert Wolf",
        firm: "Robert Wolf",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "483544-00"
      },
      {
        name: "Round Hill Capital",
        firm: "Round Hill Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "55242-19"
      },
      {
        name: "Scrum Ventures",
        firm: "Scrum Ventures",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "57349-27"
      },
      {
        name: "Sega Sammy Holdings",
        firm: "Sega Sammy Holdings",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "59614-57"
      },
      {
        name: "Selected Works",
        firm: "Selected Works",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "691907-41"
      },
      {
        name: "Spartan Venture Group",
        firm: "Spartan Venture Group",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "749229-22"
      },
      {
        name: "The Players Fund",
        firm: "The Players Fund",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "534450-61"
      },
      {
        name: "Todd Dagres",
        firm: "Todd Dagres",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "110908-18"
      },
      {
        name: "Transform Investments",
        firm: "Transform Investments",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "279871-48"
      },
      {
        name: "TriplePoint Capital",
        firm: "TriplePoint Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "40668-76"
      },
      {
        name: "United Talent Agency",
        firm: "United Talent Agency",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "57177-55"
      },
      {
        name: "Vincent Viola",
        firm: "Vincent Viola",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "110722-15"
      },
      {
        name: "Vishal Gandhi",
        firm: "Vishal Gandhi",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2024-06-24",
        pitchbook_id: "606954-70"
      },
      {
        name: "25madison",
        firm: "25madison",
        rounds: [
          "Early Stage VC",
          "Series A"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "231698-98"
      },
      {
        name: "Alex Albon",
        firm: "Alex Albon",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "522408-43"
      },
      {
        name: "Alex Morgan",
        firm: "Alex Morgan",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "483791-95"
      },
      {
        name: "AMBSE Ventures",
        firm: "AMBSE Ventures",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "489570-31"
      },
      {
        name: "Apex Capital (Portugal)",
        firm: "Apex Capital (Portugal)",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "469243-81"
      },
      {
        name: "AyBe",
        firm: "AyBe",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "54819-55"
      },
      {
        name: "Carlos Sainz",
        firm: "Carlos Sainz",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "483984-37"
      },
      {
        name: "Connect Ventures (Venture Capital)",
        firm: "Connect Ventures (Venture Capital)",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC",
          "Series A"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "491079-79"
      },
      {
        name: "Darius Rucker",
        firm: "Darius Rucker",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "465788-71"
      },
      {
        name: "Dick Ebersol",
        firm: "Dick Ebersol",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "507315-07"
      },
      {
        name: "Dwyane Wade",
        firm: "Dwyane Wade",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "229436-20"
      },
      {
        name: "Eric Grubman",
        firm: "Eric Grubman",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "507315-43"
      },
      {
        name: "Fenway Sports Group",
        firm: "Fenway Sports Group",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "51197-59"
      },
      {
        name: "First Serve Partners",
        firm: "First Serve Partners",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "266533-93"
      },
      {
        name: "Gareth Bale",
        firm: "Gareth Bale",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "522407-44"
      },
      {
        name: "Greg Maffei",
        firm: "Greg Maffei",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "328275-55"
      },
      {
        name: "Jake Owen",
        firm: "Jake Owen",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "229855-60"
      },
      {
        name: "John Collins",
        firm: "John Collins",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "484596-01"
      },
      {
        name: "John Daly",
        firm: "John Daly",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "507320-29"
      },
      {
        name: "Josh Allen",
        firm: "Josh Allen",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC",
          "Series A"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "460298-17"
      },
      {
        name: "Justin Bieber",
        firm: "Justin Bieber",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "106345-45"
      },
      {
        name: "Justin Timberlake",
        firm: "Justin Timberlake",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "106214-41"
      },
      {
        name: "Kern Egan",
        firm: "Kern Egan",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "519544-81"
      },
      {
        name: "Kevin Durant",
        firm: "Kevin Durant",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC",
          "Series A"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "166439-35"
      },
      {
        name: "Khaled Mohamed Khaled",
        firm: "Khaled Mohamed Khaled",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "277901-47"
      },
      {
        name: "Lando Norris",
        firm: "Lando Norris",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "522409-60"
      },
      {
        name: "Larry Fitzgerald",
        firm: "Larry Fitzgerald",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC",
          "Series A"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "398878-39"
      },
      {
        name: "Lewis Hamilton",
        firm: "Lewis Hamilton",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "466795-27"
      },
      {
        name: "Michael Rubin",
        firm: "Michael Rubin",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "106544-98"
      },
      {
        name: "Mike Trout",
        firm: "Mike Trout",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC",
          "Series A"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "510747-49"
      },
      {
        name: "NewBound Venture Capital",
        firm: "NewBound Venture Capital",
        rounds: [
          "Series A",
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "267398-02"
      },
      {
        name: "Serena Williams",
        firm: "Serena Williams",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "223408-18"
      },
      {
        name: "Seven Seven Six",
        firm: "Seven Seven Six",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "439547-77"
      },
      {
        name: "Shaquille O'Neal",
        firm: "Shaquille O'Neal",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "168548-68"
      },
      {
        name: "Shohei Ohtani",
        firm: "Shohei Ohtani",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "522406-99"
      },
      {
        name: "Sidney Crosby",
        firm: "Sidney Crosby",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "522407-80"
      },
      {
        name: "Stephen Curry",
        firm: "Stephen Curry",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "110813-68"
      },
      {
        name: "Symphony Ventures (Ireland)",
        firm: "Symphony Ventures (Ireland)",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "435416-95"
      },
      {
        name: "Thirty Five Ventures",
        firm: "Thirty Five Ventures",
        rounds: [
          "Early Stage VC",
          "Series A"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "234080-11"
      },
      {
        name: "Tiger Woods Ventures",
        firm: "Tiger Woods Ventures",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "494639-02"
      },
      {
        name: "Tony Romo",
        firm: "Tony Romo",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "522407-98"
      },
      {
        name: "Trea Turner",
        firm: "Trea Turner",
        status: "Lead Investor",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "496194-67"
      },
      {
        name: "Will Ventures",
        firm: "Will Ventures",
        rounds: [
          "Early Stage VC",
          "Series A"
        ],
        stake: "Minority",
        since: "2023-03-21",
        pitchbook_id: "268707-52"
      }
    ],
    board_members: [],
    investments_buy_side: []
  },

  "232830-28": {
    company_id: "232830-28",
    name: "Legacy (Devices and Supplies)",
    status: "Active",
    industry: "Other Devices and Supplies",
    founded: "2017-01-01",
    celebrity_investors: [
      "Justin Bieber"
    ],
    website: "www.givelegacy.com",
    description: "Developer of male fertility testing and preservation kits designed to make deposits from home without having to visit a clinic. The company's kits assist in sperm analysis, improvement, and cryogenic storage, and offer kits to test and preserve sperms, enabling clients to test and freeze their sperms and preserve their fertility at home.",
    keywords: [
      "fertility care",
      "fertility technology",
      "genetic material",
      "male fertility analysis",
      "male fertility assessment",
      "sperm freezing kits",
      "sperm preservation"
    ],
    latest_funding: {
      round_type: "Series A1",
      date: "2021-04-14",
      amount: 9999999,
      valuation: 40000000,
      post_money_valuation: 40000000,
      lead_investor: "Orlando Bloom",
      other_investors: [
        "Chestnut Street Ventures",
        "Oyster Ventures",
        "Peak State Ventures",
        "The MBA Fund",
        "TQ Ventures"
      ]
    },
    financials: {
      revenue_ttm: 4321,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 30000001
    },
    team: [
      {
        name: "Khaled Kteily",
        role: "Founder & Chief Executive Officer",
        background: ""
      }
    ],
    deal_history: [
      {
        date: "2018-12-01",
        round: "Grant",
        amount: 50000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 1,
        lead_investor: ""
      },
      {
        date: "2019-01-01",
        round: "Accelerator/Inc",
        amount: 150000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 1,
        lead_investor: ""
      },
      {
        date: "2019-10-24",
        round: "Accelerator/Inc",
        amount: 0,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 1,
        lead_investor: "MassChallenge"
      },
      {
        date: "2019-11-26",
        round: "Seed",
        amount: 1500000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 8,
        lead_investor: "Bain Capital Ventures"
      },
      {
        date: "2020-01-31",
        round: "Series A",
        amount: 3500000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 8,
        lead_investor: "S32"
      },
      {
        date: "2021-04-14",
        round: "Series A1",
        amount: 9999999,
        valuation: 40000000,
        pre_money_valuation: 0,
        investors: 10,
        lead_investor: "Orlando Bloom"
      },
      {
        date: "2022-05-12",
        round: "Series B",
        amount: 25000002,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 14,
        lead_investor: "Bain Capital Ventures"
      },
      {
        date: "2024-07-17",
        round: "Later Stage VC",
        amount: 7500000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 7,
        lead_investor: ""
      }
    ],
    cap_table: {
      "Series B-1": "3.07",
      "Series B": "14.46",
      "Series A-3": "3.27",
      "Series A-2": "7.05",
      "Series A-1": "19.66",
      "Seed 7": "3.97",
      "Seed 6": "0.77",
      "Seed 5": "0.05",
      "Seed 4": "0.48",
      "Seed 3": "0.32",
      "Seed 2": "1.94",
      "Seed 1": "0.32",
      "Common Stock": "44.64"
    },
    investors: [
      {
        name: "2468 Ventures",
        firm: "2468 Ventures",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2024-07-17",
        pitchbook_id: "732074-14"
      },
      {
        name: "Dedicated Venture Capital",
        firm: "Dedicated Venture Capital",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2024-07-17",
        pitchbook_id: "436815-28"
      },
      {
        name: "MaasInvest",
        firm: "MaasInvest",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2024-07-17",
        pitchbook_id: "224227-99"
      },
      {
        name: "Samsung NEXT Ventures",
        firm: "Samsung NEXT Ventures",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2024-07-17",
        pitchbook_id: "166690-90"
      },
      {
        name: "Toloka",
        firm: "Toloka",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2024-07-17",
        pitchbook_id: "539235-82"
      },
      {
        name: "Trac (San Francisco)",
        firm: "Trac (San Francisco)",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2024-07-17",
        pitchbook_id: "433201-69"
      },
      {
        name: "What If Ventures",
        firm: "What If Ventures",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2024-07-17",
        pitchbook_id: "279553-24"
      },
      {
        name: "Duro Ventures",
        firm: "Duro Ventures",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-05-12",
        pitchbook_id: "442688-41"
      },
      {
        name: "Pres10 Ventures",
        firm: "Pres10 Ventures",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-05-12",
        pitchbook_id: "544787-02"
      },
      {
        name: "Reform Ventures",
        firm: "Reform Ventures",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-05-12",
        pitchbook_id: "268061-50"
      },
      {
        name: "Tamar Capital",
        firm: "Tamar Capital",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-05-12",
        pitchbook_id: "233143-66"
      },
      {
        name: "Valor Equity Partners",
        firm: "Valor Equity Partners",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-05-12",
        pitchbook_id: "10297-90"
      },
      {
        name: "Valspring Capital",
        firm: "Valspring Capital",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-05-12",
        pitchbook_id: "512303-86"
      },
      {
        name: "Abel Tesfaye",
        firm: "Abel Tesfaye",
        status: "Lead Investor",
        rounds: [
          "Series A1"
        ],
        stake: "Minority",
        since: "2021-04-14",
        pitchbook_id: "384736-24"
      },
      {
        name: "Chestnut Street Ventures",
        firm: "Chestnut Street Ventures",
        rounds: [
          "Series A1"
        ],
        stake: "Minority",
        since: "2021-04-14",
        pitchbook_id: "179487-73"
      },
      {
        name: "FirstMark Capital",
        firm: "FirstMark Capital",
        status: "Lead Investor",
        rounds: [
          "Series B",
          "Series A1"
        ],
        stake: "Minority",
        since: "2021-04-14",
        pitchbook_id: "11270-53"
      },
      {
        name: "Justin Bieber",
        firm: "Justin Bieber",
        status: "Lead Investor",
        rounds: [
          "Series B",
          "Series A1"
        ],
        stake: "Minority",
        since: "2021-04-14",
        pitchbook_id: "106345-45"
      },
      {
        name: "Khaled Mohamed Khaled",
        firm: "Khaled Mohamed Khaled",
        status: "Lead Investor",
        rounds: [
          "Series B",
          "Series A1"
        ],
        stake: "Minority",
        since: "2021-04-14",
        pitchbook_id: "277901-47"
      },
      {
        name: "Orlando Bloom",
        firm: "Orlando Bloom",
        status: "Lead Investor",
        rounds: [
          "Series B",
          "Series A1"
        ],
        stake: "Minority",
        since: "2021-04-14",
        pitchbook_id: "222971-68"
      },
      {
        name: "Oyster Ventures",
        firm: "Oyster Ventures",
        rounds: [
          "Series A1"
        ],
        stake: "Minority",
        since: "2021-04-14",
        pitchbook_id: "230408-20"
      },
      {
        name: "Peak State Ventures",
        firm: "Peak State Ventures",
        rounds: [
          "Series A1"
        ],
        stake: "Minority",
        since: "2021-04-14",
        pitchbook_id: "232331-86"
      },
      {
        name: "The MBA Fund",
        firm: "The MBA Fund",
        rounds: [
          "Series A1"
        ],
        stake: "Minority",
        since: "2021-04-14",
        pitchbook_id: "268231-96"
      },
      {
        name: "TQ Ventures",
        firm: "TQ Ventures",
        rounds: [
          "Series B",
          "Series A1"
        ],
        stake: "Minority",
        since: "2021-04-14",
        pitchbook_id: "232265-71"
      },
      {
        name: "Exitfund",
        firm: "Exitfund",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2020-01-31",
        pitchbook_id: "548145-19"
      },
      {
        name: "Magic Fund",
        firm: "Magic Fund",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2020-01-31",
        pitchbook_id: "437720-05"
      },
      {
        name: "S32",
        firm: "S32",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series B"
        ],
        stake: "Minority",
        since: "2020-01-31",
        pitchbook_id: "168850-63"
      },
      {
        name: "Spade Ventures",
        firm: "Spade Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2020-01-31",
        pitchbook_id: "530807-68"
      },
      {
        name: "VentureSouq",
        firm: "VentureSouq",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2020-01-31",
        pitchbook_id: "181056-43"
      },
      {
        name: "Alumni Ventures",
        firm: "Alumni Ventures",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Seed",
          "Series B"
        ],
        stake: "Minority",
        since: "2019-11-26",
        pitchbook_id: "60082-66"
      },
      {
        name: "AMK Investment Office",
        firm: "AMK Investment Office",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-11-26",
        pitchbook_id: "279927-91"
      },
      {
        name: "Bain Capital Ventures",
        firm: "Bain Capital Ventures",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Seed",
          "Series B"
        ],
        stake: "Minority",
        since: "2019-11-26",
        pitchbook_id: "42202-18"
      },
      {
        name: "Basecamp Fund",
        firm: "Basecamp Fund",
        rounds: [
          "Seed"
        ],
        stake: "Majority",
        since: "2019-11-26",
        pitchbook_id: "294500-35"
      },
      {
        name: "Globivest",
        firm: "Globivest",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-11-26",
        pitchbook_id: "463162-06"
      },
      {
        name: "Tribe Capital",
        firm: "Tribe Capital",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-11-26",
        pitchbook_id: "231972-49"
      },
      {
        name: "Valia Ventures",
        firm: "Valia Ventures",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-11-26",
        pitchbook_id: "169957-36"
      },
      {
        name: "Waterline Ventures",
        firm: "Waterline Ventures",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-11-26",
        pitchbook_id: "97202-35"
      },
      {
        name: "MassChallenge",
        firm: "MassChallenge",
        status: "Lead Investor",
        rounds: [
          "Accelerator/Inc"
        ],
        since: "2019-10-24",
        pitchbook_id: "54360-28"
      },
      {
        name: "Y Combinator",
        firm: "Y Combinator",
        rounds: [
          "Series A",
          "Accelerator/Inc"
        ],
        stake: "Minority",
        since: "2019-01-01",
        pitchbook_id: "40420-36"
      },
      {
        name: "Startup Battlefield",
        firm: "Startup Battlefield",
        rounds: [
          "Grant"
        ],
        since: "2018-12-01",
        pitchbook_id: "158736-16"
      }
    ],
    board_members: [],
    investments_buy_side: []
  },

  "266376-70": {
    company_id: "266376-70",
    name: "MoonPay USA",
    status: "Active",
    industry: "Financial Software",
    founded: "2018-01-01",
    celebrity_investors: [
      "Justin Bieber"
    ],
    website: "www.moonpay.com",
    description: "Developer of a digital asset payment platform designed for secure and accessible participation in blockchain-based financial systems. The company's platform supports fiat-to-crypto and crypto-to-fiat conversions, integrates with wallets and decentralized applications, enabling global retail users and businesses to access, manage, with regulatory compliance and enterprise-grade security.",
    keywords: [
      "bitcoin service",
      "crypto exchange",
      "cryptocurrency payment",
      "digital asset",
      "onboarding and payment",
      "payment gateway",
      "payment infrastructure",
      "transaction tools"
    ],
    latest_funding: {
      round_type: "Series A",
      date: "2022-04-13",
      amount: 555000000,
      valuation: 3400000000,
      post_money_valuation: 3400000000,
      lead_investor: "Tiger Global Management",
      other_investors: [
        "11:11 Media",
        "1/1 Capital",
        "7feur",
        "AG Ventures",
        "Alecla7",
        "Andreessen Horowitz",
        "Animoca Brands",
        "Artfo Holdings",
        "Atacama Ventures",
        "Castle Island Ventures",
        "Chapter One",
        "Connect Ventures (Venture Capital)",
        "Digital (US)",
        "Diplo",
        "DreamCrew",
        "FEWOCiOUS",
        "FJ Labs",
        "Global Tech Ventures",
        "HOF Capital",
        "Human Capital",
        "Hypescale Ventures",
        "I2BF Global Ventures",
        "Ignite CLI",
        "K2 Global",
        "Kora Management",
        "Mantis VC",
        "MarcyPen Capital Partners",
        "Night Ventures",
        "Northstar.VC",
        "Plus Capital",
        "Polygon Studios",
        "Quiet Capital",
        "Shrug Capital",
        "Solana (Investor)",
        "TA Ventures",
        "The Aventures",
        "The Chainsmokers",
        "The Ropart Asset Management Funds",
        "Thrive Capital",
        "Tribe Capital",
        "True Capital Management",
        "Valhalla Ventures",
        "Warner Music Group",
        "Wave7",
        "ZoiBel",
        "JAWS Estates Capital"
      ]
    },
    financials: {
      revenue_ttm: 150000000,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 2845000000
    },
    team: [
      {
        name: "Victor Faramond",
        role: "Co-Founder & Chief Engineer",
        background: ""
      }
    ],
    deal_history: [
      {
        date: "2021-12-20",
        round: "Series A",
        amount: 0,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 12,
        lead_investor: "Paradigm (Crypto Fund)"
      },
      {
        date: "2022-04-13",
        round: "Series A",
        amount: 555000000,
        valuation: 3400000000,
        pre_money_valuation: 0,
        investors: 121,
        lead_investor: "Tiger Global Management"
      },
      {
        date: "2023-09-26",
        round: "Later Stage VC",
        amount: 0,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 10,
        lead_investor: ""
      },
      {
        date: "2025-01-22",
        round: "Later Stage VC",
        amount: 202283280,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 6,
        lead_investor: ""
      }
    ],
    cap_table: {},
    investors: [
      {
        name: "Fabric Ventures",
        firm: "Fabric Ventures",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2025-01-22",
        pitchbook_id: "232529-05"
      },
      {
        name: "Future Perfect Ventures",
        firm: "Future Perfect Ventures",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2025-01-22",
        pitchbook_id: "60478-12"
      },
      {
        name: "Inflection",
        firm: "Inflection",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2025-01-22",
        pitchbook_id: "433592-74"
      },
      {
        name: "Nortiyus",
        firm: "Nortiyus",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2025-01-22",
        pitchbook_id: "864139-15"
      },
      {
        name: "Peak (Amsterdam)",
        firm: "Peak (Amsterdam)",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2025-01-22",
        pitchbook_id: "60593-77"
      },
      {
        name: "Vis Capital",
        firm: "Vis Capital",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2025-01-22",
        pitchbook_id: "265616-38"
      },
      {
        name: "Anti Fund",
        firm: "Anti Fund",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2023-09-26",
        pitchbook_id: "466453-54"
      },
      {
        name: "Big Loud Capital",
        firm: "Big Loud Capital",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2023-09-26",
        pitchbook_id: "166984-39"
      },
      {
        name: "Cobalt Capital (Santa Monica)",
        firm: "Cobalt Capital (Santa Monica)",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2023-09-26",
        pitchbook_id: "432677-62"
      },
      {
        name: "Genesis Accel",
        firm: "Genesis Accel",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2023-09-26",
        pitchbook_id: "489551-68"
      },
      {
        name: "MAVA Ventures",
        firm: "MAVA Ventures",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2023-09-26",
        pitchbook_id: "279775-63"
      },
      {
        name: "New Wave Capital (Italy)",
        firm: "New Wave Capital (Italy)",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2023-09-26",
        pitchbook_id: "533120-86"
      },
      {
        name: "Palm Tree Crew Crypto",
        firm: "Palm Tree Crew Crypto",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2023-09-26",
        pitchbook_id: "513168-76"
      },
      {
        name: "Shake and Bake",
        firm: "Shake and Bake",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2023-09-26",
        pitchbook_id: "594197-02"
      },
      {
        name: "Trust Fund",
        firm: "Trust Fund",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2023-09-26",
        pitchbook_id: "500690-71"
      },
      {
        name: "WndrCo",
        firm: "WndrCo",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2023-09-26",
        pitchbook_id: "170084-35"
      },
      {
        name: "11:11 Media",
        firm: "11:11 Media",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495795-97"
      },
      {
        name: "1/1 Capital",
        firm: "1/1 Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "489217-87"
      },
      {
        name: "7feur",
        firm: "7feur",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "489554-02"
      },
      {
        name: "Abel Tesfaye",
        firm: "Abel Tesfaye",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "384736-24"
      },
      {
        name: "Adel Nur",
        firm: "Adel Nur",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495389-08"
      },
      {
        name: "Afshin Shahidi",
        firm: "Afshin Shahidi",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495397-18"
      },
      {
        name: "AG Ventures",
        firm: "AG Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "471952-36"
      },
      {
        name: "Ahmir Thompson",
        firm: "Ahmir Thompson",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "153461-08"
      },
      {
        name: "Alecla7",
        firm: "Alecla7",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "458087-86"
      },
      {
        name: "Amir Esmailian",
        firm: "Amir Esmailian",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "432771-31"
      },
      {
        name: "Andreessen Horowitz",
        firm: "Andreessen Horowitz",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "41716-90"
      },
      {
        name: "Animoca Brands",
        firm: "Animoca Brands",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "65039-59"
      },
      {
        name: "Anthony Kiedis",
        firm: "Anthony Kiedis",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495387-64"
      },
      {
        name: "Artfo Holdings",
        firm: "Artfo Holdings",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "459826-21"
      },
      {
        name: "Ashton Kutcher",
        firm: "Ashton Kutcher",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "106033-87"
      },
      {
        name: "Atacama Ventures",
        firm: "Atacama Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "122870-26"
      },
      {
        name: "Aubrey Graham",
        firm: "Aubrey Graham",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "234016-75"
      },
      {
        name: "BLOND ISH",
        firm: "BLOND ISH",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495387-73"
      },
      {
        name: "Blossom Capital",
        firm: "Blossom Capital",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "226255-51"
      },
      {
        name: "Brent Faiyaz",
        firm: "Brent Faiyaz",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "460301-77"
      },
      {
        name: "Brie Larson",
        firm: "Brie Larson",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495388-18"
      },
      {
        name: "Bruce Willis",
        firm: "Bruce Willis",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "481548-34"
      },
      {
        name: "Calvin Broadus",
        firm: "Calvin Broadus",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "106158-97"
      },
      {
        name: "Castle Island Ventures",
        firm: "Castle Island Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "230037-67"
      },
      {
        name: "Champ Medici",
        firm: "Champ Medici",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495395-29"
      },
      {
        name: "Chapter One",
        firm: "Chapter One",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "234705-97"
      },
      {
        name: "Connect Ventures (Venture Capital)",
        firm: "Connect Ventures (Venture Capital)",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "491079-79"
      },
      {
        name: "David Grutman",
        firm: "David Grutman",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "467848-09"
      },
      {
        name: "Digital (US)",
        firm: "Digital (US)",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "497930-95"
      },
      {
        name: "Dimitri Vegas",
        firm: "Dimitri Vegas",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "484212-88"
      },
      {
        name: "Diplo",
        firm: "Diplo",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "463230-64"
      },
      {
        name: "Drake Nur",
        firm: "Drake Nur",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495389-35"
      },
      {
        name: "DreamCrew",
        firm: "DreamCrew",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "471718-99"
      },
      {
        name: "Eric Eisner",
        firm: "Eric Eisner",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495389-62"
      },
      {
        name: "Evan Longoria",
        firm: "Evan Longoria",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "432816-58"
      },
      {
        name: "FEWOCiOUS",
        firm: "FEWOCiOUS",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "470069-11"
      },
      {
        name: "FJ Labs",
        firm: "FJ Labs",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "108358-57"
      },
      {
        name: "Gal Gadot",
        firm: "Gal Gadot",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "494978-68"
      },
      {
        name: "Gee Roberson",
        firm: "Gee Roberson",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "384737-68"
      },
      {
        name: "Gerald Gillum",
        firm: "Gerald Gillum",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "227459-89"
      },
      {
        name: "Gibson Hazard",
        firm: "Gibson Hazard",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495389-98"
      },
      {
        name: "Global Tech Ventures",
        firm: "Global Tech Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "490966-39"
      },
      {
        name: "Gwyneth Paltrow",
        firm: "Gwyneth Paltrow",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "162886-33"
      },
      {
        name: "HOF Capital",
        firm: "HOF Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "126970-03"
      },
      {
        name: "Human Capital",
        firm: "Human Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "181950-40"
      },
      {
        name: "Hypescale Ventures",
        firm: "Hypescale Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "515824-93"
      },
      {
        name: "I2BF Global Ventures",
        firm: "I2BF Global Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "42864-40"
      },
      {
        name: "Ignite CLI",
        firm: "Ignite CLI",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "155159-20"
      },
      {
        name: "James Corden",
        firm: "James Corden",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "277901-83"
      },
      {
        name: "Jamil Davis",
        firm: "Jamil Davis",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "493788-52"
      },
      {
        name: "Jason Derulo",
        firm: "Jason Derulo",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "481216-78"
      },
      {
        name: "Jayne Andrews",
        firm: "Jayne Andrews",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "493166-62"
      },
      {
        name: "Jonathan Golden",
        firm: "Jonathan Golden",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "459032-41"
      },
      {
        name: "Justin Bieber",
        firm: "Justin Bieber",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "106345-45"
      },
      {
        name: "K2 Global",
        firm: "K2 Global",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "121955-23"
      },
      {
        name: "Karan Wadhera",
        firm: "Karan Wadhera",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "431601-40"
      },
      {
        name: "Kate Hudson",
        firm: "Kate Hudson",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "264090-43"
      },
      {
        name: "Katie McGrath",
        firm: "Katie McGrath",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495391-51"
      },
      {
        name: "Keri Shahidi",
        firm: "Keri Shahidi",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495396-91"
      },
      {
        name: "Kevin Yorn",
        firm: "Kevin Yorn",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "112211-38"
      },
      {
        name: "Kimberly Blackwell",
        firm: "Kimberly Blackwell",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495392-32"
      },
      {
        name: "Kinship Ventures",
        firm: "Kinship Ventures",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495079-75"
      },
      {
        name: "Kora Management",
        firm: "Kora Management",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "436658-23"
      },
      {
        name: "Larry Gagosian",
        firm: "Larry Gagosian",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495392-59"
      },
      {
        name: "Like Mike",
        firm: "Like Mike",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "484213-06"
      },
      {
        name: "Lil Baby",
        firm: "Lil Baby",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "491653-27"
      },
      {
        name: "Lil Durk",
        firm: "Lil Durk",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495393-04"
      },
      {
        name: "Mantis VC",
        firm: "Mantis VC",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "431348-32"
      },
      {
        name: "Marc Benioff",
        firm: "Marc Benioff",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "106035-13"
      },
      {
        name: "MarcyPen Capital Partners",
        firm: "MarcyPen Capital Partners",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "230023-00"
      },
      {
        name: "Maria Sharapova",
        firm: "Maria Sharapova",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "156704-05"
      },
      {
        name: "Matt Bauerschmidt",
        firm: "Matt Bauerschmidt",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "493789-42"
      },
      {
        name: "Matt Colon",
        firm: "Matt Colon",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "481388-86"
      },
      {
        name: "Matte Babel",
        firm: "Matte Babel",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495393-40"
      },
      {
        name: "Matthew McConaughey",
        firm: "Matthew McConaughey",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "232677-19"
      },
      {
        name: "Michael Ovitz",
        firm: "Michael Ovitz",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "106040-71"
      },
      {
        name: "Mindy Kaling",
        firm: "Mindy Kaling",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "432514-45"
      },
      {
        name: "Moj Mahdara",
        firm: "Moj Mahdara",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "231087-79"
      },
      {
        name: "Nancy Twine",
        firm: "Nancy Twine",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495393-67"
      },
      {
        name: "Nick Adler",
        firm: "Nick Adler",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "494295-13"
      },
      {
        name: "Night Ventures",
        firm: "Night Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "466744-42"
      },
      {
        name: "Northstar.VC",
        firm: "Northstar.VC",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "461976-67"
      },
      {
        name: "Paris Hilton",
        firm: "Paris Hilton",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "435385-90"
      },
      {
        name: "Paul George",
        firm: "Paul George",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "433235-80"
      },
      {
        name: "Plus Capital",
        firm: "Plus Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "56613-25"
      },
      {
        name: "Polygon Studios",
        firm: "Polygon Studios",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "482261-68"
      },
      {
        name: "Post Malone",
        firm: "Post Malone",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "434812-42"
      },
      {
        name: "Quiet Capital",
        firm: "Quiet Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "231270-40"
      },
      {
        name: "Rick Yorn",
        firm: "Rick Yorn",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "153929-80"
      },
      {
        name: "Ryan Tedder",
        firm: "Ryan Tedder",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "265839-40"
      },
      {
        name: "Sam Feldt",
        firm: "Sam Feldt",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495394-66"
      },
      {
        name: "Scooter Braun",
        firm: "Scooter Braun",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "106326-55"
      },
      {
        name: "Shailene Woodley",
        firm: "Shailene Woodley",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "435386-08"
      },
      {
        name: "Shawn Mendes",
        firm: "Shawn Mendes",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "222892-48"
      },
      {
        name: "Shay Mitchell",
        firm: "Shay Mitchell",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "469235-71"
      },
      {
        name: "Shrug Capital",
        firm: "Shrug Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "227750-86"
      },
      {
        name: "Solana (Investor)",
        firm: "Solana (Investor)",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "484259-05"
      },
      {
        name: "Sound Ventures",
        firm: "Sound Ventures",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "110390-41"
      },
      {
        name: "Stacey Bendet",
        firm: "Stacey Bendet",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495395-56"
      },
      {
        name: "Steve Aoki",
        firm: "Steve Aoki",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "115259-23"
      },
      {
        name: "TA Ventures",
        firm: "TA Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "54660-43"
      },
      {
        name: "The Aventures",
        firm: "The Aventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "490008-70"
      },
      {
        name: "The Chainsmokers",
        firm: "The Chainsmokers",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "438008-32"
      },
      {
        name: "The Ropart Asset Management Funds",
        firm: "The Ropart Asset Management Funds",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "11285-56"
      },
      {
        name: "Thrive Capital",
        firm: "Thrive Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "51625-90"
      },
      {
        name: "Tribe Capital",
        firm: "Tribe Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "231972-49"
      },
      {
        name: "Trina Spear",
        firm: "Trina Spear",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495395-92"
      },
      {
        name: "True Capital Management",
        firm: "True Capital Management",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "227460-88"
      },
      {
        name: "Ty Baisden",
        firm: "Ty Baisden",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "471719-71"
      },
      {
        name: "Ullas Naik",
        firm: "Ullas Naik",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "105986-71"
      },
      {
        name: "Valhalla Ventures",
        firm: "Valhalla Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "466610-23"
      },
      {
        name: "Warner Music Group",
        firm: "Warner Music Group",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "10793-80"
      },
      {
        name: "Wave7",
        firm: "Wave7",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "491628-07"
      },
      {
        name: "Yara Shahidi",
        firm: "Yara Shahidi",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "495396-10"
      },
      {
        name: "Zoe Saldana",
        firm: "Zoe Saldana",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "156628-81"
      },
      {
        name: "ZoiBel",
        firm: "ZoiBel",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-04-13",
        pitchbook_id: "494141-14"
      },
      {
        name: "BroadLight Capital",
        firm: "BroadLight Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "467623-81"
      },
      {
        name: "Coatue Management",
        firm: "Coatue Management",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "56091-70"
      },
      {
        name: "Foundation Capital",
        firm: "Foundation Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "11193-13"
      },
      {
        name: "Green Bay Ventures",
        firm: "Green Bay Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "168354-82"
      },
      {
        name: "J.A.S Ventures",
        firm: "J.A.S Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "517314-16"
      },
      {
        name: "JAWS Estates Capital",
        firm: "JAWS Estates Capital",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "122491-72"
      },
      {
        name: "K5 Global",
        firm: "K5 Global",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "343248-58"
      },
      {
        name: "New Enterprise Associates",
        firm: "New Enterprise Associates",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "11251-81"
      },
      {
        name: "Paradigm (Crypto Fund)",
        firm: "Paradigm (Crypto Fund)",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "233744-05"
      },
      {
        name: "RSJ Investments",
        firm: "RSJ Investments",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "63170-47"
      },
      {
        name: "Tiger Global Management",
        firm: "Tiger Global Management",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "42873-94"
      },
      {
        name: "Weekend Fund",
        firm: "Weekend Fund",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2021-12-20",
        pitchbook_id: "343304-47"
      },
      {
        name: "Blockchain Capital",
        firm: "Blockchain Capital",
        rounds: [],
        stake: "Minority",
        pitchbook_id: "62119-72"
      }
    ],
    board_members: [],
    investments_buy_side: []
  },

  "112924-99": {
    company_id: "112924-99",
    name: "Liquid I.V.",
    status: "Active",
    industry: "Food Products",
    founded: "2012-01-01",
    celebrity_investors: [
      "Justin Bieber"
    ],
    website: "www.liquid-iv.com",
    description: "Producer of hydration beverage products created to defeat global dehydration. The company's hydration products deliver water and other key nutrients directly to the bloodstream for faster more efficient hydration than water alone and better absorption of nutrients through the use of Cellular Transport Technology, providing consumers with a beverage to combat the negative effects of dehydration caused by intense physical exertion, active lifestyles, jet lag, and even alcohol consumption.",
    keywords: [
      "beverage product",
      "hydration beverages",
      "hydration drinks",
      "hydration product",
      "no preservatives food",
      "vegan food"
    ],
    latest_funding: {
      round_type: "Later Stage VC",
      date: "2019-07-24",
      amount: 5000000,
      valuation: 0,
      post_money_valuation: 0,
      lead_investor: null,
      other_investors: []
    },
    financials: {
      revenue_ttm: 1000000000,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 0
    },
    team: [],
    deal_history: [
      {
        date: "2019-07-24",
        round: "Later Stage VC",
        amount: 5000000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 0,
        lead_investor: ""
      }
    ],
    cap_table: {},
    investors: [],
    board_members: [],
    investments_buy_side: []
  },

  "171639-28": {
    company_id: "171639-28",
    name: "Rumble Fitness",
    status: "Active",
    industry: "Leisure Facilities",
    founded: "2017-01-01",
    celebrity_investors: [
      "Justin Bieber"
    ],
    website: "www.rumbleboxinggym.com",
    description: "Provider of fitness training services intended to offer boxing-inspired fitness classes to customers. The company's services include full-body strength training and conditioning workouts crafted around specially designed water-filled, teardrop-style boxing bags and a blend of hip-hop and house music in customized mash-ups, enabling customers to be in shape, remain fit and lead a healthy life.",
    keywords: [
      "body workout",
      "fitness center",
      "fitness centres",
      "fitness classes",
      "fitness training",
      "fitness training service"
    ],
    latest_funding: {
      round_type: "Early Stage VC",
      date: "2018-04-25",
      amount: 21500000,
      valuation: 99500000,
      post_money_valuation: 99500000,
      lead_investor: null,
      other_investors: []
    },
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 78000000
    },
    team: [
      {
        name: "Noah Neiman",
        role: "Co-Founder",
        background: ""
      }
    ],
    deal_history: [
      {
        date: "2018-04-25",
        round: "Early Stage VC",
        amount: 21500000,
        valuation: 99500000,
        pre_money_valuation: 0,
        investors: 0,
        lead_investor: ""
      }
    ],
    cap_table: {},
    investors: [],
    board_members: [],
    investments_buy_side: []
  }
,

  "223431-67": {
    company_id: "223431-67",
    name: "Forethought",
    status: "Active",
    industry: "Business/Productivity Software",
    founded: "2017-01-01",
    celebrity_investors: [
      "Gwyneth Paltrow"
    ],
    website: "www.forethought.ai",
    description: "Developer of artificial intelligence-powered tools designed to embed relevant information into the daily workflows of employees proactively. The company's tool immediately responds to customers, resolves simple issues with real-time assistance, automates repetitive routing that agents spend valuable time doing and provides insights, enabling businesses to decrease their resolution time and increase agent productivity.",
    keywords: [
      "ai automation platform",
      "customer queries solving",
      "customer service automation",
      "customer service tool",
      "customer support application",
      "customer support automation"
    ],
    latest_funding: {
      round_type: "Series C",
      date: "2021-12-03",
      amount: 65000000,
      valuation: 314999999,
      post_money_valuation: 314999999,
      lead_investor: "K9 Ventures",
      other_investors: [
        "Cleo Capital",
        "Collaborative Fund",
        "Plug and Play Tech Center",
        "Spearhead (VC)",
        "Worklife Ventures",
        "Sound Ventures"
      ]
    },
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 249999999
    },
    team: [
      {
        name: "Deon Nicholas",
        role: "Co-Founder, President & Executive Chairman",
        background: ""
      }
    ],
    deal_history: [
      {
        date: "2018-03-06",
        round: "Seed",
        amount: 10000000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 11,
        lead_investor: "Yan-David Erlich"
      },
      {
        date: "2018-09-08",
        round: "Grant",
        amount: 100000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 1,
        lead_investor: ""
      },
      {
        date: "2018-12-04",
        round: "Series A",
        amount: 9515978,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 18,
        lead_investor: "Octave (San Francisco)"
      },
      {
        date: "2020-10-28",
        round: "Series B",
        amount: 16999996,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 20,
        lead_investor: "Julien Boubel"
      },
      {
        date: "2021-12-03",
        round: "Series C",
        amount: 65000000,
        valuation: 314999999,
        pre_money_valuation: 0,
        investors: 20,
        lead_investor: "K9 Ventures"
      },
      {
        date: "2025-04-07",
        round: "Series D",
        amount: 24999991,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 10,
        lead_investor: "Gwyneth Paltrow"
      }
    ],
    cap_table: {
      "Series D": "22.73",
      "Series 6": "1.55",
      "Series 5": "0.29",
      "Series 4": "1.84",
      "Series 3": "2.13",
      "Series 2": "0.32",
      "Series 1": "1.24",
      "Common Stock": "69.90"
    },
    investors: [
      {
        name: "Blue Cloud Ventures",
        firm: "Blue Cloud Ventures",
        status: "Lead Investor",
        rounds: [
          "Series D"
        ],
        stake: "Minority",
        since: "2025-04-07",
        pitchbook_id: "61817-68"
      },
      {
        name: "Industry Ventures",
        firm: "Industry Ventures",
        rounds: [
          "Series D"
        ],
        stake: "Minority",
        since: "2025-04-07",
        pitchbook_id: "11217-34"
      },
      {
        name: "Karan Goel",
        firm: "Karan Goel",
        status: "Lead Investor",
        rounds: [
          "Series D"
        ],
        stake: "Minority",
        since: "2025-04-07",
        pitchbook_id: "472013-74"
      },
      {
        name: "May Habib",
        firm: "May Habib",
        status: "Lead Investor",
        rounds: [
          "Series D"
        ],
        stake: "Minority",
        since: "2025-04-07",
        pitchbook_id: "820872-46"
      },
      {
        name: "Scott Wu",
        firm: "Scott Wu",
        status: "Lead Investor",
        rounds: [
          "Series D"
        ],
        stake: "Minority",
        since: "2025-04-07",
        pitchbook_id: "711419-68"
      },
      {
        name: "Adrienne Harris",
        firm: "Adrienne Harris",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "471669-58"
      },
      {
        name: "Andrea Coravos",
        firm: "Andrea Coravos",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "463355-29"
      },
      {
        name: "Baron Davis",
        firm: "Baron Davis",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "226052-20"
      },
      {
        name: "Christopher Manning",
        firm: "Christopher Manning",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "470874-61"
      },
      {
        name: "Cleo Capital",
        firm: "Cleo Capital",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "232227-82"
      },
      {
        name: "Collaborative Fund",
        firm: "Collaborative Fund",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "51595-21"
      },
      {
        name: "Daniel Nadler",
        firm: "Daniel Nadler",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "489131-11"
      },
      {
        name: "Frontline Ventures",
        firm: "Frontline Ventures",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "54840-88"
      },
      {
        name: "Gwyneth Paltrow",
        firm: "Gwyneth Paltrow",
        status: "Lead Investor",
        rounds: [
          "Series C",
          "Series D"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "162886-33"
      },
      {
        name: "Jason Boehmig",
        firm: "Jason Boehmig",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "343166-59"
      },
      {
        name: "Plug and Play Tech Center",
        firm: "Plug and Play Tech Center",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "54172-81"
      },
      {
        name: "Robert Downey",
        firm: "Robert Downey",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "178894-18"
      },
      {
        name: "Spearhead (VC)",
        firm: "Spearhead (VC)",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "483791-23"
      },
      {
        name: "STEADFAST Capital Ventures",
        firm: "STEADFAST Capital Ventures",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "62279-47"
      },
      {
        name: "Taylor Greene",
        firm: "Taylor Greene",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "229055-23"
      },
      {
        name: "Trevor McFedries",
        firm: "Trevor McFedries",
        status: "Lead Investor",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "442316-98"
      },
      {
        name: "Worklife Ventures",
        firm: "Worklife Ventures",
        rounds: [
          "Series C"
        ],
        stake: "Minority",
        since: "2021-12-03",
        pitchbook_id: "301265-11"
      },
      {
        name: "Brianne Kimmel",
        firm: "Brianne Kimmel",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2020-10-28",
        pitchbook_id: "267070-60"
      },
      {
        name: "Henry Ward",
        firm: "Henry Ward",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2020-10-28",
        pitchbook_id: "433326-25"
      },
      {
        name: "January Bromberger",
        firm: "January Bromberger",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2020-10-28",
        pitchbook_id: "442802-17"
      },
      {
        name: "John-Paul Gallo",
        firm: "John-Paul Gallo",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2020-10-28",
        pitchbook_id: "455085-37"
      },
      {
        name: "Philippe Jabre",
        firm: "Philippe Jabre",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2020-10-28",
        pitchbook_id: "489131-74"
      },
      {
        name: "South Park Commons",
        firm: "South Park Commons",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2020-10-28",
        pitchbook_id: "230619-43"
      },
      {
        name: "Sri Pangulur",
        firm: "Sri Pangulur",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2020-10-28",
        pitchbook_id: "454693-15"
      },
      {
        name: "Alexa von Tobel",
        firm: "Alexa von Tobel",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "232480-00"
      },
      {
        name: "Ashton Kutcher",
        firm: "Ashton Kutcher",
        status: "Lead Investor",
        rounds: [
          "Series C",
          "Series B",
          "Series A"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "106033-87"
      },
      {
        name: "Geodesic Capital",
        firm: "Geodesic Capital",
        status: "Lead Investor",
        rounds: [
          "Series B",
          "Series A"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "114742-18"
      },
      {
        name: "James Todd Smith",
        firm: "James Todd Smith",
        status: "Lead Investor",
        rounds: [
          "Series B",
          "Series A"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "443054-08"
      },
      {
        name: "Kelvin Beachum",
        firm: "Kelvin Beachum",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series B"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "224380-81"
      },
      {
        name: "Mathilde Collin",
        firm: "Mathilde Collin",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "184160-08"
      },
      {
        name: "Neo (Consulting Services (B2B))",
        firm: "Neo (Consulting Services (B2B))",
        rounds: [
          "Series A",
          "Series B",
          "Series D"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "56299-96"
      },
      {
        name: "New Enterprise Associates",
        firm: "New Enterprise Associates",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series D",
          "Series B"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "11251-81"
      },
      {
        name: "Operator Collective",
        firm: "Operator Collective",
        rounds: [
          "Series A",
          "Series B"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "375602-95"
      },
      {
        name: "Ryan Smith",
        firm: "Ryan Smith",
        status: "Lead Investor",
        rounds: [
          "Series B",
          "Series A"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "179953-30"
      },
      {
        name: "Samsung NEXT Ventures",
        firm: "Samsung NEXT Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "166690-90"
      },
      {
        name: "Sean Combs",
        firm: "Sean Combs",
        status: "Lead Investor",
        rounds: [
          "Series B",
          "Series A"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "106563-97"
      },
      {
        name: "Sound Ventures",
        firm: "Sound Ventures",
        rounds: [
          "Series C",
          "Series B",
          "Series D",
          "Series A"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "110390-41"
      },
      {
        name: "Vlad Tenev",
        firm: "Vlad Tenev",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2018-12-04",
        pitchbook_id: "226771-21"
      },
      {
        name: "Startup Battlefield",
        firm: "Startup Battlefield",
        rounds: [
          "Grant"
        ],
        since: "2018-09-08",
        pitchbook_id: "158736-16"
      },
      {
        name: "8VC",
        firm: "8VC",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "149720-23"
      },
      {
        name: "Brennan O'Donnell",
        firm: "Brennan O'Donnell",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "107653-24"
      },
      {
        name: "Julien Boubel",
        firm: "Julien Boubel",
        status: "Lead Investor",
        rounds: [
          "Seed",
          "Series B"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "156599-56"
      },
      {
        name: "K9 Ventures",
        firm: "K9 Ventures",
        status: "Lead Investor",
        rounds: [
          "Series B",
          "Series A",
          "Seed",
          "Series C"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "45703-99"
      },
      {
        name: "Michael Junge",
        firm: "Michael Junge",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "442848-79"
      },
      {
        name: "Octave (San Francisco)",
        firm: "Octave (San Francisco)",
        status: "Lead Investor",
        rounds: [
          "Seed",
          "Series A"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "464439-79"
      },
      {
        name: "Original Capital",
        firm: "Original Capital",
        rounds: [
          "Seed",
          "Series A",
          "Series B"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "228040-12"
      },
      {
        name: "Ruchi Sanghvi",
        firm: "Ruchi Sanghvi",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "222253-66"
      },
      {
        name: "Suranga Chandratillake",
        firm: "Suranga Chandratillake",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "439827-22"
      },
      {
        name: "Village Global",
        firm: "Village Global",
        rounds: [
          "Series D",
          "Series A",
          "Seed"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "187442-38"
      },
      {
        name: "Yan-David Erlich",
        firm: "Yan-David Erlich",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2018-03-06",
        pitchbook_id: "228255-49"
      }
    ],
    board_members: [],
    investments_buy_side: []
  },

  "343114-03": {
    company_id: "343114-03",
    name: "Kudos (Personal Products)",
    status: "Active",
    industry: "Personal Products",
    founded: "2019-01-01",
    celebrity_investors: [
      "Gwyneth Paltrow"
    ],
    website: "www.mykudos.com",
    description: "Manufacturer of diapers and wipes intended to offer clean, non-toxic, eco-friendly baby care products. The company's diapers feature absorption layers and a cotton liner designed to protect babies' sensitive skin and provide overnight protection, enabling customers to avail natural diapers that suit babies' skin.",
    keywords: [
      "baby care",
      "baby diaper manufacturer",
      "baby wipes",
      "diapers pads",
      "disposable baby diapers",
      "eco-friendly diapers"
    ],
    latest_funding: {
      round_type: "Seed",
      date: "2024-07-11",
      amount: 3800001,
      valuation: 18000001,
      post_money_valuation: 18000001,
      lead_investor: "Xfund",
      other_investors: [
        "Five Two Five",
        "Net Zero Angels",
        "Precursor Ventures"
      ]
    },
    financials: {
      revenue_ttm: 850000,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 14200000
    },
    team: [
      {
        name: "Amrita Saigal",
        role: "Founder & Chief Executive Officer",
        background: ""
      }
    ],
    deal_history: [
      {
        date: "2021-06-01",
        round: "Seed",
        amount: 2400000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 10,
        lead_investor: "PJC"
      },
      {
        date: "2021-09-17",
        round: "Accelerator/Inc",
        amount: 100000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 1,
        lead_investor: ""
      },
      {
        date: "2024-07-11",
        round: "Seed",
        amount: 3800001,
        valuation: 18000001,
        pre_money_valuation: 0,
        investors: 9,
        lead_investor: "Xfund"
      }
    ],
    cap_table: {
      "Seed-1": "16.39",
      "Seed-6": "5.90",
      "Seed-4": "1.69",
      "Seed-3": "24.87",
      "Seed-5": "6.36",
      "Seed-2": "0.13",
      "Common Stock": "44.66"
    },
    investors: [
      {
        name: "Alumni Ventures",
        firm: "Alumni Ventures",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2024-07-11",
        pitchbook_id: "60082-66"
      },
      {
        name: "Five Two Five",
        firm: "Five Two Five",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2024-07-11",
        pitchbook_id: "591152-50"
      },
      {
        name: "Freedom Trail Capital",
        firm: "Freedom Trail Capital",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2024-07-11",
        pitchbook_id: "539178-58"
      },
      {
        name: "Gwyneth Paltrow",
        firm: "Gwyneth Paltrow",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2024-07-11",
        pitchbook_id: "162886-33"
      },
      {
        name: "Mark Cuban",
        firm: "Mark Cuban",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2024-07-11",
        pitchbook_id: "105884-29"
      },
      {
        name: "Net Zero Angels",
        firm: "Net Zero Angels",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2024-07-11",
        pitchbook_id: "500623-48"
      },
      {
        name: "Oversubscribed Ventures",
        firm: "Oversubscribed Ventures",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2024-07-11",
        pitchbook_id: "495563-59"
      },
      {
        name: "TiE Women",
        firm: "TiE Women",
        rounds: [
          "Accelerator/Inc"
        ],
        since: "2021-09-17",
        pitchbook_id: "502837-03"
      },
      {
        name: "Alpha Bridge Ventures",
        firm: "Alpha Bridge Ventures",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-01",
        pitchbook_id: "232199-83"
      },
      {
        name: "April Underwood",
        firm: "April Underwood",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-01",
        pitchbook_id: "114612-76"
      },
      {
        name: "Foundation Capital",
        firm: "Foundation Capital",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-01",
        pitchbook_id: "11193-13"
      },
      {
        name: "Liquid 2 Ventures",
        firm: "Liquid 2 Ventures",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-01",
        pitchbook_id: "149517-28"
      },
      {
        name: "Matthew Caspari",
        firm: "Matthew Caspari",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-01",
        pitchbook_id: "458505-10"
      },
      {
        name: "PJC",
        firm: "PJC",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-01",
        pitchbook_id: "11273-95"
      },
      {
        name: "Precursor Ventures",
        firm: "Precursor Ventures",
        rounds: [
          "Seed",
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-01",
        pitchbook_id: "125084-71"
      },
      {
        name: "SV Angel",
        firm: "SV Angel",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-01",
        pitchbook_id: "50980-60"
      },
      {
        name: "Underscore VC",
        firm: "Underscore VC",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-01",
        pitchbook_id: "152407-00"
      },
      {
        name: "Xfund",
        firm: "Xfund",
        status: "Lead Investor",
        rounds: [
          "Seed",
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-01",
        pitchbook_id: "53775-82"
      }
    ],
    board_members: [],
    investments_buy_side: []
  },

  "521393-59": {
    company_id: "521393-59",
    name: "Wild",
    status: "Active",
    industry: "Social/Platform Software",
    founded: "2022-01-01",
    celebrity_investors: [
      "Gwyneth Paltrow"
    ],
    website: "www.wild.xyz",
    description: "Developer of an art creator platform designed to bring together emerging and established makers to learn, grow and reimagine art. The company's platform lets users support their favorite makers, discover new art, the stories and people behind it and build their collection of originals and virtual goods, enabling users to connect with the art community, explore new worlds and enjoy creativity.",
    keywords: [
      "art community",
      "art creation",
      "art creation platform",
      "art industry",
      "art learning",
      "art work"
    ],
    latest_funding: {
      round_type: "Seed",
      date: "2023-03-09",
      amount: 7000000,
      valuation: 0,
      post_money_valuation: 0,
      lead_investor: "Reid Hoffman",
      other_investors: [
        "Matrix",
        "Western Technology Investment"
      ]
    },
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 0
    },
    team: [
      {
        name: "John Kobs",
        role: "Founder & Chief Executive Officer",
        background: ""
      }
    ],
    deal_history: [
      {
        date: "2023-03-09",
        round: "Seed",
        amount: 7000000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 6,
        lead_investor: "Reid Hoffman"
      }
    ],
    cap_table: {},
    investors: [
      {
        name: "Cozomo de' Medici",
        firm: "Cozomo de' Medici",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2023-03-09",
        pitchbook_id: "490225-69"
      },
      {
        name: "Gwyneth Paltrow",
        firm: "Gwyneth Paltrow",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2023-03-09",
        pitchbook_id: "162886-33"
      },
      {
        name: "Kevin Lin",
        firm: "Kevin Lin",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2023-03-09",
        pitchbook_id: "228061-81"
      },
      {
        name: "Matrix",
        firm: "Matrix",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2023-03-09",
        pitchbook_id: "11237-50"
      },
      {
        name: "Reid Hoffman",
        firm: "Reid Hoffman",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2023-03-09",
        pitchbook_id: "105945-22"
      },
      {
        name: "Western Technology Investment",
        firm: "Western Technology Investment",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2023-03-09",
        pitchbook_id: "11335-42"
      }
    ],
    board_members: [],
    investments_buy_side: []
  },

  "233310-25": {
    company_id: "233310-25",
    name: "ResortPass",
    status: "Active",
    industry: "Other Restaurants, Hotels and Leisure",
    founded: "2016-01-01",
    celebrity_investors: [
      "Gwyneth Paltrow"
    ],
    website: "www.resortpass.com",
    description: "Developer of an online hotel and resort booking platform designed to offer access to resorts and hotels for pool, spa, fitness and activities. The company's platform provides an entire system for hotels to benefit from a significant new revenue channel which includes inventory and pricing management, online booking, revenue data and reporting, marketing and full guest support, enabling locals and travelers to enjoy leisure amenities at amazing hotel properties without needing to book a room.",
    keywords: [
      "amusement industry",
      "booking engine",
      "hospitality application",
      "hotel amenities",
      "hotel booking",
      "relaxing lounge"
    ],
    latest_funding: {
      round_type: "Series B",
      date: "2022-10-19",
      amount: 25999984,
      valuation: 90999985,
      post_money_valuation: 90999985,
      lead_investor: "CRV",
      other_investors: [
        "AirAngels",
        "Declaration Partners",
        "Endeavor Group Holdings",
        "FJ Labs",
        "K5 Global",
        "Plug and Play Tech Center"
      ]
    },
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 65000001
    },
    team: [],
    deal_history: [
      {
        date: "2018-04-01",
        round: "Seed",
        amount: 600000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 1,
        lead_investor: ""
      },
      {
        date: "2018-06-14",
        round: "Seed",
        amount: 2000000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 5,
        lead_investor: "Jim Brandt"
      },
      {
        date: "2019-08-19",
        round: "Series A",
        amount: 8999997,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 9,
        lead_investor: "Jim Brandt"
      },
      {
        date: "2022-10-19",
        round: "Series B",
        amount: 25999984,
        valuation: 90999985,
        pre_money_valuation: 0,
        investors: 13,
        lead_investor: "CRV"
      }
    ],
    cap_table: {
      "Series B": "28.57",
      "Series A": "16.07",
      "Seed 4": "8.69",
      "Seed 3": "2.40",
      "Seed 2": "2.29",
      "Seed 1": "4.24",
      "Common Stock": "37.74"
    },
    investors: [
      {
        name: "14W",
        firm: "14W",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "97899-13"
      },
      {
        name: "Adam Grant",
        firm: "Adam Grant",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "170656-75"
      },
      {
        name: "AirAngels",
        firm: "AirAngels",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "437575-24"
      },
      {
        name: "Brian Kelly",
        firm: "Brian Kelly",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "118566-28"
      },
      {
        name: "Burst Capital",
        firm: "Burst Capital",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "233424-82"
      },
      {
        name: "Declaration Partners",
        firm: "Declaration Partners",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "227416-24"
      },
      {
        name: "Endeavor Group Holdings",
        firm: "Endeavor Group Holdings",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "53004-70"
      },
      {
        name: "FJ Labs",
        firm: "FJ Labs",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "108358-57"
      },
      {
        name: "Gwyneth Paltrow",
        firm: "Gwyneth Paltrow",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "162886-33"
      },
      {
        name: "Jessica Warren",
        firm: "Jessica Warren",
        status: "Lead Investor",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "115610-68"
      },
      {
        name: "K5 Global",
        firm: "K5 Global",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "343248-58"
      },
      {
        name: "Plug and Play Tech Center",
        firm: "Plug and Play Tech Center",
        rounds: [
          "Series B"
        ],
        stake: "Minority",
        since: "2022-10-19",
        pitchbook_id: "54172-81"
      },
      {
        name: "Carson Mehl",
        firm: "Carson Mehl",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2019-08-19",
        pitchbook_id: "464494-42"
      },
      {
        name: "Convivialité Ventures",
        firm: "Convivialité Ventures",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2019-08-19",
        pitchbook_id: "183839-23"
      },
      {
        name: "DoorDash",
        firm: "DoorDash",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2019-08-19",
        pitchbook_id: "58167-28"
      },
      {
        name: "Ed Walters",
        firm: "Ed Walters",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2019-08-19",
        pitchbook_id: "465326-29"
      },
      {
        name: "Jeffrey Lapin",
        firm: "Jeffrey Lapin",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2019-08-19",
        pitchbook_id: "222518-89"
      },
      {
        name: "Luc Levesque",
        firm: "Luc Levesque",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2019-08-19",
        pitchbook_id: "399558-07"
      },
      {
        name: "Mark Moran",
        firm: "Mark Moran",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2019-08-19",
        pitchbook_id: "222419-17"
      },
      {
        name: "Uber",
        firm: "Uber",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2019-08-19",
        pitchbook_id: "51136-75"
      },
      {
        name: "CRV",
        firm: "CRV",
        status: "Lead Investor",
        rounds: [
          "Series B",
          "Seed"
        ],
        stake: "Minority",
        since: "2018-06-14",
        pitchbook_id: "10133-20"
      },
      {
        name: "Jim Brandt",
        firm: "Jim Brandt",
        status: "Lead Investor",
        rounds: [
          "Seed",
          "Series A"
        ],
        stake: "Minority",
        since: "2018-06-14",
        pitchbook_id: "111498-49"
      },
      {
        name: "Mucker Capital",
        firm: "Mucker Capital",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2018-06-14",
        pitchbook_id: "54305-83"
      },
      {
        name: "Tamarisc Ventures",
        firm: "Tamarisc Ventures",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2018-06-14",
        pitchbook_id: "98811-91"
      },
      {
        name: "TCA Venture Group",
        firm: "TCA Venture Group",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2018-06-14",
        pitchbook_id: "10322-83"
      },
      {
        name: "Wayfare Ventures",
        firm: "Wayfare Ventures",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2018-04-01",
        pitchbook_id: "188058-88"
      }
    ],
    board_members: [],
    investments_buy_side: []
  },

  "432851-68": {
    company_id: "432851-68",
    name: "Evernow",
    status: "Active",
    industry: "Other Healthcare Technology Systems",
    founded: "2019-01-01",
    celebrity_investors: [
      "Gwyneth Paltrow"
    ],
    website: "www.evernow.com",
    description: "Developer of an online teleconsultation platform designed to guide women during and after menopause. The company's platform has online access to specialized doctors, science-backed pieces of information, and treatments with conversations and information about effective care for changing hormones, enabling women to live longer and healthier lives.",
    keywords: [
      "health platform",
      "menopause care",
      "online teleconsultation platform",
      "perimenopause advice",
      "personalized medicine",
      "prescription fulfillment",
      "women's health",
      "women's wellness"
    ],
    latest_funding: {
      round_type: "Series A",
      date: "2022-09-30",
      amount: 28500000,
      valuation: 0,
      post_money_valuation: 0,
      lead_investor: "Refactor Capital",
      other_investors: [
        "Gaingels",
        "Hands On Angel",
        "Mana Ventures",
        "Sheila Marcelo",
        "Hustle Fund"
      ]
    },
    financials: {
      revenue_ttm: 0,
      growth_rate: 0,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 0
    },
    team: [
      {
        name: "Alicia Jackson",
        role: "Co-Founder & Chief Executive Officer",
        background: ""
      }
    ],
    deal_history: [
      {
        date: "2020-06-29",
        round: "Series A",
        amount: 24000004,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 8,
        lead_investor: "Gwynne Shotwell"
      },
      {
        date: "2022-09-30",
        round: "Series A",
        amount: 28500000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 22,
        lead_investor: "Refactor Capital"
      },
      {
        date: "2025-03-01",
        round: "Later Stage VC",
        amount: 0,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 2,
        lead_investor: ""
      }
    ],
    cap_table: {
      "Series A-3": "10.82",
      "Series A-2": "18.58",
      "Series A-1": "21.05",
      "Common Stock": "49.55"
    },
    investors: [
      {
        name: "Ensemble Labs",
        firm: "Ensemble Labs",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2025-03-01",
        pitchbook_id: "464189-32"
      },
      {
        name: "Impact Assets",
        firm: "Impact Assets",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2025-03-01",
        pitchbook_id: "57625-84"
      },
      {
        name: "8VC",
        firm: "8VC",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "149720-23"
      },
      {
        name: "Alumni Ventures",
        firm: "Alumni Ventures",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "60082-66"
      },
      {
        name: "Cameron Diaz",
        firm: "Cameron Diaz",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "435446-29"
      },
      {
        name: "Carla Harris",
        firm: "Carla Harris",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "494717-95"
      },
      {
        name: "Demi Moore",
        firm: "Demi Moore",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "226803-61"
      },
      {
        name: "Drew Barrymore",
        firm: "Drew Barrymore",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "494718-31"
      },
      {
        name: "Gaingels",
        firm: "Gaingels",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "124929-82"
      },
      {
        name: "Gwyneth Paltrow",
        firm: "Gwyneth Paltrow",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "162886-33"
      },
      {
        name: "Hands On Angel",
        firm: "Hands On Angel",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "535692-34"
      },
      {
        name: "Liza Landsman",
        firm: "Liza Landsman",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "452745-82"
      },
      {
        name: "Mana Ventures",
        firm: "Mana Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "187876-90"
      },
      {
        name: "Milkbox Partners",
        firm: "Milkbox Partners",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "153318-88"
      },
      {
        name: "New Enterprise Associates",
        firm: "New Enterprise Associates",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "11251-81"
      },
      {
        name: "Othman Laraki",
        firm: "Othman Laraki",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "105967-00"
      },
      {
        name: "Sheila Marcelo",
        firm: "Sheila Marcelo",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "223346-71"
      },
      {
        name: "Vanessa Larco",
        firm: "Vanessa Larco",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-09-30",
        pitchbook_id: "489343-87"
      },
      {
        name: "Abigail Wambach",
        firm: "Abigail Wambach",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2020-06-29",
        pitchbook_id: "464365-90"
      },
      {
        name: "Coelius Capital",
        firm: "Coelius Capital",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2020-06-29",
        pitchbook_id: "327402-91"
      },
      {
        name: "Glennon Doyle",
        firm: "Glennon Doyle",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2020-06-29",
        pitchbook_id: "494718-94"
      },
      {
        name: "Gwynne Shotwell",
        firm: "Gwynne Shotwell",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2020-06-29",
        pitchbook_id: "182427-76"
      },
      {
        name: "Hustle Fund",
        firm: "Hustle Fund",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2020-06-29",
        pitchbook_id: "187469-20"
      },
      {
        name: "Natural Bridge Ventures",
        firm: "Natural Bridge Ventures",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2020-06-29",
        pitchbook_id: "436797-46"
      },
      {
        name: "Pipeline Capital Partners",
        firm: "Pipeline Capital Partners",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2020-06-29",
        pitchbook_id: "128432-53"
      },
      {
        name: "Refactor Capital",
        firm: "Refactor Capital",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series A"
        ],
        stake: "Minority",
        since: "2020-06-29",
        pitchbook_id: "155859-76"
      }
    ],
    board_members: [],
    investments_buy_side: []
  },

  "392361-04": {
    company_id: "392361-04",
    name: "Crown Affair",
    status: "Active",
    industry: "Personal Products",
    founded: "2019-01-01",
    celebrity_investors: [
      "Gwyneth Paltrow"
    ],
    website: "www.crownaffair.com",
    description: "Developer of hair care products intended to access the guidance, tools, and community the consumers need to redefine their relationship with their hair. The company specializes in creating products that are vegan and cruelty-free and offers products like brushes, towels, oil, sets, scrunchies, and renewal masks with recyclable, reusable, and compostable packaging, enabling users to avail themselves of environment-friendly beauty care products and get them delivered to their homes.",
    keywords: [
      "green beauty",
      "hair care",
      "hair oil",
      "natural hair care",
      "organic hair care",
      "vegan hair care"
    ],
    latest_funding: {
      round_type: "Series A",
      date: "2022-05-13",
      amount: 7490479,
      valuation: 23740479,
      post_money_valuation: 23740479,
      lead_investor: "Jaclyn Johnson",
      other_investors: [
        "LB Equity",
        "Rose Street Capital",
        "Sidekick Partners",
        "Stage 1 Fund",
        "Westrie Capital",
        "Montage Ventures"
      ]
    },
    financials: {
      revenue_ttm: 30000000,
      growth_rate: 0.5,
      burn_rate: 0,
      runway_months: 0,
      pre_money_valuation: 16250000
    },
    team: [
      {
        name: "Dianna Cohen",
        role: "Founder, Co-Chief Executive Officer & Board Member",
        background: ""
      }
    ],
    deal_history: [
      {
        date: "2019-12-18",
        round: "Seed",
        amount: 1735000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 9,
        lead_investor: "Shiza Shahid"
      },
      {
        date: "2021-06-08",
        round: "Seed",
        amount: 1265000,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 2,
        lead_investor: "Alumni Ventures"
      },
      {
        date: "2022-05-13",
        round: "Series A",
        amount: 7490479,
        valuation: 23740479,
        pre_money_valuation: 0,
        investors: 9,
        lead_investor: "Jaclyn Johnson"
      },
      {
        date: "2022-09-01",
        round: "Early Stage VC",
        amount: 0,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 2,
        lead_investor: ""
      },
      {
        date: "2024-05-23",
        round: "Later Stage VC",
        amount: 3599999.5245000003,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 2,
        lead_investor: ""
      },
      {
        date: "2024-11-21",
        round: "Series B",
        amount: 8999999,
        valuation: 0,
        pre_money_valuation: 0,
        investors: 4,
        lead_investor: "True Beauty Ventures"
      }
    ],
    cap_table: {
      "Series B-1": "15.65",
      "Series B-3": "3.85",
      "Series B-2": "7.32",
      "Series A": "26.30",
      Seed: "9.18",
      "Common Stock": "37.70"
    },
    investors: [
      {
        name: "Amberstone",
        firm: "Amberstone",
        rounds: [
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2024-05-23",
        pitchbook_id: "436392-46"
      },
      {
        name: "Selva Ventures",
        firm: "Selva Ventures",
        rounds: [
          "Series B",
          "Later Stage VC"
        ],
        stake: "Minority",
        since: "2024-05-23",
        pitchbook_id: "399654-73"
      },
      {
        name: "PEAK6 Strategic Capital",
        firm: "PEAK6 Strategic Capital",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2022-09-01",
        pitchbook_id: "483966-37"
      },
      {
        name: "Point King Capital",
        firm: "Point King Capital",
        rounds: [
          "Early Stage VC"
        ],
        stake: "Minority",
        since: "2022-09-01",
        pitchbook_id: "268406-47"
      },
      {
        name: "Gwyneth Paltrow",
        firm: "Gwyneth Paltrow",
        status: "Lead Investor",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-05-13",
        pitchbook_id: "162886-33"
      },
      {
        name: "LB Equity",
        firm: "LB Equity",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-05-13",
        pitchbook_id: "125377-21"
      },
      {
        name: "Rose Street Capital",
        firm: "Rose Street Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-05-13",
        pitchbook_id: "437036-50"
      },
      {
        name: "Sidekick Partners",
        firm: "Sidekick Partners",
        rounds: [
          "Series A",
          "Series B"
        ],
        stake: "Minority",
        since: "2022-05-13",
        pitchbook_id: "482240-71"
      },
      {
        name: "Stage 1 Fund",
        firm: "Stage 1 Fund",
        rounds: [
          "Series A",
          "Series B"
        ],
        stake: "Minority",
        since: "2022-05-13",
        pitchbook_id: "277914-97"
      },
      {
        name: "True Beauty Ventures",
        firm: "True Beauty Ventures",
        status: "Lead Investor",
        rounds: [
          "Series A",
          "Series B"
        ],
        stake: "Minority",
        since: "2022-05-13",
        pitchbook_id: "443279-71"
      },
      {
        name: "Westrie Capital",
        firm: "Westrie Capital",
        rounds: [
          "Series A"
        ],
        stake: "Minority",
        since: "2022-05-13",
        pitchbook_id: "470711-71"
      },
      {
        name: "Alumni Ventures",
        firm: "Alumni Ventures",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2021-06-08",
        pitchbook_id: "60082-66"
      },
      {
        name: "Montage Ventures",
        firm: "Montage Ventures",
        rounds: [
          "Seed",
          "Series A"
        ],
        stake: "Minority",
        since: "2021-06-08",
        pitchbook_id: "60007-78"
      },
      {
        name: "Amplifyher Ventures",
        firm: "Amplifyher Ventures",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-12-18",
        pitchbook_id: "233906-95"
      },
      {
        name: "Brand Foundry Ventures",
        firm: "Brand Foundry Ventures",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-12-18",
        pitchbook_id: "63633-25"
      },
      {
        name: "Brian Spaly",
        firm: "Brian Spaly",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-12-18",
        pitchbook_id: "106285-15"
      },
      {
        name: "Christina Hirukawa",
        firm: "Christina Hirukawa",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-12-18",
        pitchbook_id: "343023-40"
      },
      {
        name: "Finn Capital Partners",
        firm: "Finn Capital Partners",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-12-18",
        pitchbook_id: "97809-49"
      },
      {
        name: "Greycroft",
        firm: "Greycroft",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-12-18",
        pitchbook_id: "11191-87"
      },
      {
        name: "Heidi Zak",
        firm: "Heidi Zak",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-12-18",
        pitchbook_id: "109159-66"
      },
      {
        name: "Jaclyn Johnson",
        firm: "Jaclyn Johnson",
        status: "Lead Investor",
        rounds: [
          "Seed",
          "Series A"
        ],
        stake: "Minority",
        since: "2019-12-18",
        pitchbook_id: "327115-90"
      },
      {
        name: "Shiza Shahid",
        firm: "Shiza Shahid",
        status: "Lead Investor",
        rounds: [
          "Seed"
        ],
        stake: "Minority",
        since: "2019-12-18",
        pitchbook_id: "460307-17"
      }
    ],
    board_members: [],
    investments_buy_side: []
  }
};

// Helper function to get company by ID
export const getCompanyById = (company_id) => {
  return mockCompanies[company_id] || null;
};

// Helper function to get all companies
export const getAllCompanies = () => {
  return Object.values(mockCompanies);
};

// Helper function to get companies by celebrity investor
export const getCompaniesByCelebrity = (celebrity_name) => {
  return Object.values(mockCompanies).filter(company => 
    company.celebrity_investors.includes(celebrity_name)
  );
};

// Helper function to get companies by status
export const getCompaniesByStatus = (status) => {
  return Object.values(mockCompanies).filter(company => company.status === status);
};